import React, { useEffect, useState, useRef } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Table, Collapse } from "react-bootstrap";
import { toast } from "react-toastify";
import instance from "../../../WebApi/WebApi";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import { TableFooter } from "@mui/material";
import "./Report.css";
import { background } from "@chakra-ui/react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { isNumber, reduce } from "lodash";
import { Tabs, Tab, Modal, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const monthToNumber = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

const Report = () => {
  const { t } = useTranslation();

  const [countryCurrencyCode, setCountryCurrencyCode] = useState("ISK");

  const [openRows, setOpenRows] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedStartMonth, setSelectedStartMonth] = useState(
    months[new Date().getMonth()]
  );
  const [selectedEndMonth, setSelectedEndMonth] = useState("Jan");
  const [selectedYear, setSelectedYear] = useState();
  // const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [businessUnitId, setBusinessUnitId] = useState(null);
  const [businessUnitData, setAllBusinessUnit] = useState([]);
  const [UNSPSCReport, setUNSPSCReport] = useState([]);
  const [years, setYears] = useState([]);
  const [grandTotalSalesAmount, setGrandTotalSalesAmount] = useState(0);
  const [grandTotalPurchaseAmount, setGrandTotalPurchaseAmount] = useState(0);
  const [expandedElementIds, setExpandedElementIds] = useState([]);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [unclassifiedProducts, setUnclassifiedProducts] = useState([]);
  const [generatingReport, setGeneratingReport] = useState(false);
  const [reportAvailableForYears, setReportAvailableForYears] = useState([]);
  const [reportAvailableForMonths, setReportAvailableForMonths] = useState([]);
  const [selectedPastOrderDetails, setSelectedPastOrderDetails] = useState({});
  const [businessUnitTotalPurchasePrice, setBusinessUnitTotalPurchasePrice] =
    useState({});
  const [
    unclassifiedProductTotalPurchasePrice,
    setUnclassifiedProductTotalPurchasePrice,
  ] = useState(0);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const abortControllerRef = useRef(null);
  const [
    grandTotalPurchaseAmountCombined,
    setGrandTotalPurchaseAmountCombined,
  ] = useState(0);
  const [loggedInUser, setLoggedInUser] = useState({});
  const [selectedProductDetails, setSelectedProductDetails] = useState({});

  const toggleSegment = (id) => {
    // console.log("id", id);
    // console.log("expandedElementIds", expandedElementIds);

    setExpandedElementIds((prevState) =>
      prevState.includes(id)
        ? prevState.filter((segmentId) => segmentId !== id)
        : [...prevState, id]
    );
  };

  // Toggle the visibility of rows when clicked
  const toggleRow = (rowId, level, index = null) => {
    setOpenRows((prevState) => {
      const newState = { ...prevState };

      if (!newState[rowId]) {
        newState[rowId] = {};
      }

      // Toggle the visibility for segment row
      if (level === "segment") {
        newState[rowId].segment = !newState[rowId].segment;
      }

      // Toggle the visibility for family-rows based on familyIndex
      if (level === "family" && index !== null) {
        newState[rowId][`family-${index}`] =
          !newState[rowId][`family-${index}`];
      }

      // Toggle the visibility for Commodity-rows based on CommodityIndex
      if (level === "commodity" && index !== null) {
        newState[rowId][`commodity-${index}`] =
          !newState[rowId][`commodity-${index}`];
      }

      // Toggle the visibility for Commodity-rows based on CommodityIndex
      if (level === "product" && index !== null) {
        newState[rowId][`product-${index}`] =
          !newState[rowId][`product-${index}`];
      }

      return newState;
    });
  };

  const handleMonthClick = (month) => {
    setSelectedStartMonth(month);
    setSelectedEndMonth(month);
    setSelectedMonth(month);
  };

  const handleYearClick = (year) => {
    setSelectedMonth(null);
    setSelectedYear(year);
    setSelectedStartMonth("Jan");
    setSelectedEndMonth(
      year === new Date().getFullYear() ? months[new Date().getMonth()] : "Dec"
    );
  };

  useEffect(() => {
    getBusinessUnit();
    getUNSPSCReport();
    getReportAvailableForYears();
    setLoggedInUser(JSON.parse(localStorage.getItem("gs3_User")));
  }, []);

  const getReportAvailableForYears = async () => {
    try {
      const response = await instance.get(`/customer/api/v1/report-for-years`);
      if (response.status === 200) {
        setReportAvailableForYears(response?.data?.data);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const getBusinessUnit = async () => {
    getAllIndustryDetailslist("").then(function (result) {
      const response = result.data;
      setAllBusinessUnit(response?.data);
    });
  };

  const getUNSPSCReport = async () => {
    setLoadingResponse(true);

    // Abort the previous request if it exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new AbortController instance
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;

    const payload = {
      month: selectedMonth,
      monthStart: selectedStartMonth,
      monthEnd: selectedEndMonth,
      year: selectedYear,
      businessUnitId: businessUnitId ?? null,
    };

    try {
      // console.log("payload------");
      // console.log(payload);

      const response = await instance.get(`/customer/api/v1/unspsc-report`, {
        params: payload,
        signal,
      });

      // console.log("response", response);
      // console.log("response", response.status);

      if (response.status === 200) {
        // console.log("response", response?.data?.data?.reports);
        setReportAvailableForMonths(
          response?.data?.data?.formattedReportMonths
        );
        setLoadingResponse(false);
        setUNSPSCReport(response?.data?.data?.reports?.classified);
        // setGrandTotalSalesAmount(response?.data?.data?.totalSalePrice);
        setGrandTotalPurchaseAmount(
          response?.data?.data?.reports?.totalPurchasePriceClassified
        );
        setUnclassifiedProducts(
          response?.data?.data?.reports?.unclassifiedReport
        );
        setUnclassifiedProductTotalPurchasePrice(
          response?.data?.data?.reports?.totalPurchasePriceUnclassified
        );
        setGrandTotalPurchaseAmountCombined(
          Number(response?.data?.data?.reports?.grandTotalPurchasePrice)
        );
        setBusinessUnitTotalPurchasePrice(
          response?.data?.data?.totalPurchasePriceOfBusinessUnits
        );
        // console.log("response", businessUnitTotalPurchasePrice);
      } else {
        setLoadingResponse(false);
        toast.error(response?.data?.message);
      }

      // console.log("response report", response?.data.data?.formattedSegments);
    } catch (err) {
      if (err.name === "AbortError") {
        // console.log("Request aborted");
      } else {
        setLoadingResponse(false);
        toast.error(err?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    function getPastYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = 2; i >= 0; i--) {
        years.push(currentYear - i);
      }
      setYears(years);
    }

    getPastYears();
  }, []);

  useEffect(() => {
    getUNSPSCReport();
  }, [selectedMonth, selectedYear, businessUnitId]);

  const filterReset = () => {
    // setSelectedYear(new Date().getFullYear());
    setSelectedYear(null);
    setBusinessUnitId("");
    setSelectedMonth(null);
    setExpandedElementIds([]);
    setSelectedStartMonth("Jan");
    setSelectedEndMonth(months[new Date().getMonth()]);
  };

  const generateReport = async () => {
    try {
      if (loggedInUser?.email !== "rafn@viridi.is") {
        toast.error("You are not authorized to generate report!");
      }

      setGeneratingReport(true);

      const response = await instance.get(`/customer/api/v1/generate-report`);

      if (response?.data?.status != 200) {
        toast.error("Report not generated!");
        setGeneratingReport(false);
      } else if (response?.data?.status == 200) {
        toast.success("Report generated successfully!");
        setGeneratingReport(false);
      }
    } catch (error) {
      setGeneratingReport(false);
      // console.error("Error generating report:", error);
      toast.error(error.response?.data?.message || "Error generating report!");
    }
  };

  const getPurchaseHistoryByProductId = async (product_id) => {
    const response = await instance.get(
      `/customer/product/get-product-details-by-id?productId=${product_id}`
    );

    if (response?.data?.status != 200) {
      toast.error("Purchase History not found!");
      // console.log("response", response);
    } else {
      // console.log("response", response?.data?.data);
      // console.log("response", response?.data?.data?.getProductDetails);
      setPurchaseHistory(response?.data?.data?.purchaseHistories);
      setSelectedProductDetails(response?.data?.data?.productDetails);
      setSelectedInvoiceId(response?.data?.data?.invoice_id);
      setShowPurchaseModal(true);
      setSelectedPastOrderDetails(response?.data?.data?.pastOrder);
    }
  };

  useEffect(() => {
    console.log("selectedProductDetails", selectedProductDetails);
  }, [selectedProductDetails]);

  const getPurchaseHistory = async (product_id, invoice_id) => {
    const data = {
      productId: product_id,
    };
    const response = await instance.post(
      `/customer/product/get-purchase-history-by-id`,
      data
    );
    setPurchaseHistory(response?.data?.data?.purchaseHistories);
    setSelectedInvoiceId(invoice_id);
    setShowPurchaseModal(true);
  };

  const thisYear = new Date().getFullYear();
  const thisMonth = new Date().getMonth(); // 0-based index for months

  const [toggleUnspscReport, setToggleUnspscReport] = useState([
    "classifiedReport",
    "unclassifiedReport",
  ]);

  const toggleReport = (reportType) => {
    // If the reportType exist then remove it else insert it in the array
    if (toggleUnspscReport.includes(reportType)) {
      setToggleUnspscReport(
        toggleUnspscReport.filter((item) => item !== reportType)
      );
    } else {
      setToggleUnspscReport([...toggleUnspscReport, reportType]);
    }
  };

  const currencyFormatter = require("currency-formatter");

  return (
    <div className="container-fluid">
      <div className="dbMain">
        <Leftpanel breadcm="Report" />
        <div className="dbRight fs-10">
          <Header link="/report" breadcm="" title={"Report"} description="" />

          <div className="commonBase">
            {/* UNSPSC Report */}
            <div className="dbtableTop mb-3 poSrch ponew">
              <div className="container mt-4">
                {/* Report Filter Options Start */}
                <div className="d-flex justify-content-between mb-3">
                  <div className="month-container mb-3">
                    {months.map((month, index) => (
                      <button
                        key={month}
                        className={`filter-month py-1 px-2
                          ${
                            selectedMonth === month
                              ? "bg-theme-green text-white"
                              : ""
                          }
                          ${
                            reportAvailableForMonths.includes(
                              monthToNumber[month]
                            )
                              ? ""
                              : "text-white disabled bg-secondary"
                          }
                          `}
                        onClick={() => handleMonthClick(month)}
                        title={
                          selectedYear
                            ? "Click to select Month"
                            : "Select Year first"
                        }
                        disabled={
                          selectedYear
                            ? selectedYear === thisYear
                              ? index > thisMonth
                              : false
                            : true
                        }
                      >
                        {month}
                      </button>
                    ))}
                  </div>
                  <div className="col-6 d-flex">
                    <div className="col-6"></div>
                    <div className="col-6">
                      <div className="d-flex justify-content-between year-container">
                        {years.map((year) => (
                          <div
                            title={
                              `${reportAvailableForYears.includes(year)}`
                                ? "Click to view Report"
                                : "Report not available for this year"
                            }
                            key={year}
                            className={`filter-year py-1 px-2 ${
                              selectedYear === year
                                ? "text-white bg-theme-green"
                                : ""
                            }
                            ${
                              reportAvailableForYears.includes(year)
                                ? ""
                                : "text-white disabled bg-secondary"
                            }`}
                            onClick={() => handleYearClick(year)}
                          >
                            {year}
                          </div>
                        ))}
                      </div>
                      <div className="dropdown-container">
                        <div className="col-12 justify-content-between d-flex flex-wrap">
                          <select
                            className="bui-dropdown"
                            value={businessUnitId}
                            onChange={(e) => setBusinessUnitId(e.target.value)}
                          >
                            <option value="" selected>
                              All Business Units
                            </option>{" "}
                            {businessUnitData.map((unit) => (
                              <option key={unit.id} value={unit.id}>
                                {unit.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12 d-flex justify-content-end mt-2">
                          {loadingResponse === true ? (
                            <button
                              className="filter-reset-btn"
                              title="Reset search filters"
                            >
                              Loading{" "}
                              <i className="fa-solid fa-spinner fa-spin ms-2"></i>
                            </button>
                          ) : (
                            <>
                              <button
                                className="filter-reset-btn"
                                title="Reset search filters"
                                onClick={() => filterReset()}
                              >
                                Reset
                              </button>
                              {loggedInUser?.email === "rafn@viridi.is" &&
                                (!generatingReport ? (
                                  <button
                                    className="report-reload-btn ms-1"
                                    title="Generate Latest report"
                                    onClick={() => generateReport()}
                                  >
                                    <i class="fa-solid fa-rotate"></i>
                                  </button>
                                ) : (
                                  <button
                                    className="report-reload-btn ms-1"
                                    title="Generate Latest report"
                                  >
                                    <i class="fa-solid fa-spin fa-rotate"></i>
                                  </button>
                                ))}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <input
                    type="checkbox"
                    className=""
                    id="classifiedReportLabel"
                    onClick={() => toggleReport("classifiedReport")}
                    checked={toggleUnspscReport.includes("classifiedReport")}
                  />{" "}
                  <span className="checkbox-text me-3">
                    <label for="classifiedReportLabel" className="pointer">
                      Classified Report
                    </label>
                  </span>
                  <input
                    type="checkbox"
                    className=""
                    id="unclassifiedReportLabel"
                    onClick={() => toggleReport("unclassifiedReport")}
                    checked={toggleUnspscReport.includes("unclassifiedReport")}
                  />{" "}
                  <span className="checkbox-text">
                    <label for="unclassifiedReportLabel" className="pointer">
                      Unclassified Report
                    </label>
                  </span>
                </div>
                {/* Report Filter Options End */}

                {/* Classified Report Start*/}
                {toggleUnspscReport.includes("classifiedReport") && (
                  <>
                    <div className="mt-3 d-flex justify-content-between">
                      <div>
                        <h6>Classified Report</h6>
                      </div>
                      <div
                        className="d-flex justify-content-end"
                        style={{ color: "#868686", "font-weight": "500" }}
                      >
                        <div className="bg-segment color-box me-1"></div>Segment
                        <div className="bg-family color-box me-1 ms-4"></div>
                        Family
                        <div className="bg-class color-box me-1 ms-4"></div>
                        Class
                        <div className="bg-commodity color-box me-1 ms-4"></div>
                        Commodity
                        <div className="bg-product color-box me-1 ms-4"></div>
                        Product
                      </div>
                    </div>
                    <div className="report-container fw-500">
                      <div
                        className="d-flex fixed-header"
                        style={{
                          width: `${
                            (businessUnitData.length + 1) * 210 + 160
                          }px`,
                        }}
                      >
                        <div className="border-end border-start border-top classification-name fixed-column">
                          UNSPSC
                        </div>
                        <div className="border-end border-top bUnitName fixed-column-2 pt-1">
                          Total
                        </div>
                        {businessUnitData &&
                          businessUnitData.map((businessUnit, index) => (
                            <div className="border-end border-top bUnitName pt-1">
                              {businessUnit?.name}
                            </div>
                          ))}
                      </div>

                      {/* Segment Heading */}
                      <div
                        className="d-flex fixed-header-2 fs-12 fw-400"
                        style={{
                          width: `${
                            (businessUnitData.length + 1) * 210 + 160
                          }px`,
                        }}
                      >
                        <div className="border classification-name fixed-column">
                          Segment
                        </div>
                        <div className="fixed-column-2 d-flex">
                          <div
                            className="border-top border-end border-bottom width-70   text-center pt-2"
                            title="Total Purchase Amount"
                          >
                            Amount
                          </div>
                          <div
                            className="border-top border-end border-bottom width-70   text-center pt-2"
                            title="Percentage of Total Purchase Amount"
                          >
                            Percentage
                          </div>
                          <div
                            className="border-top border-end border-bottom width-70   text-center pt-2"
                            title="Average Of Base Unit Price"
                          >
                            Average
                          </div>
                        </div>
                        {businessUnitData &&
                          businessUnitData.map((businessUnit, index) => (
                            <>
                              <div
                                className="border-top border-end border-bottom width-70   text-center pt-2"
                                title="Total Purchase Amount"
                              >
                                Amount
                              </div>
                              <div
                                className="border-top border-end border-bottom width-70   text-center pt-2"
                                title="Percentage of Total Purchase Amount"
                              >
                                Percentage
                              </div>
                              <div
                                className="border-top border-end border-bottom width-70   text-center pt-2"
                                title="Average Of Base Unit Price"
                              >
                                Average
                              </div>
                            </>
                          ))}
                      </div>

                      {UNSPSCReport &&
                        UNSPSCReport?.map((segment, segmentIndex) => (
                          <>
                            {/* Segment List */}
                            <div
                              className="d-flex color-segment"
                              style={{
                                width: `${
                                  (businessUnitData.length + 1) * 210 + 160
                                }px`,
                              }}
                            >
                              <div className="border-start border-end border-bottom classification-name fixed-column">
                                <button
                                  className="segment-btn color-segment ps-0"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#segment-${segmentIndex}`}
                                  aria-expanded="false"
                                  aria-controls={`segment-${segmentIndex}`}
                                  onClick={() =>
                                    toggleSegment("segment-" + segmentIndex)
                                  }
                                  title={segment.SegmentTitle}
                                >
                                  {expandedElementIds.includes(
                                    "segment-" + segmentIndex
                                  ) ? (
                                    <i className="fa-solid fa-minus me-1"></i>
                                  ) : (
                                    <i className="fa-solid fa-plus me-1"></i>
                                  )}

                                  {segment?.SegmentTitle.length > 18
                                    ? segment.SegmentTitle.slice(0, 18) + "..."
                                    : segment.SegmentTitle}
                                </button>
                              </div>
                              <div className="fixed-column-2 d-flex">
                                <div className="border-bottom border-end width-70   text-center pt-2">
                                  ISK{" "}
                                  {segment?.businessUnitPurchasePrice &&
                                    currencyFormatter
                                      .format(
                                        Object.values(
                                          segment.businessUnitPurchasePrice
                                        ).reduce((acc, value) => {
                                          return acc + value;
                                        }, 0),
                                        {
                                          code: "ISK",
                                        }
                                      )
                                      .replace("kr.", "")
                                      .trim()}
                                </div>
                                <div
                                  className="border-bottom border-end width-70   text-center pt-2"
                                  title={
                                    (
                                      (segment?.purchasePriceTotal /
                                        grandTotalPurchaseAmountCombined) *
                                      100
                                    ).toFixed(5) + "%" || ""
                                  }
                                >
                                  {(
                                    (segment?.purchasePriceTotal /
                                      grandTotalPurchaseAmountCombined) *
                                    100
                                  ).toFixed(2) + "%" || ""}
                                </div>
                                <div
                                  className="border-bottom border-end width-70   text-center pt-2"
                                  title={`Total Base Units ${
                                    Object.values(segment.baseUnitList).reduce(
                                      (acc, value) => acc + value,
                                      0
                                    ) || 1
                                  }
                                  `}
                                >
                                  ISK{" "}
                                  {segment?.baseUnitList &&
                                    currencyFormatter
                                      .format(
                                        Object.values(
                                          segment.businessUnitPurchasePrice
                                        ).reduce((acc, value) => {
                                          return acc + value;
                                        }, 0) /
                                          (Object.values(
                                            segment.baseUnitList
                                          ).reduce(
                                            (acc, value) => acc + value,
                                            0
                                          ) || 1),
                                        {
                                          code: "ISK",
                                        }
                                      )
                                      .replace("kr.", "")
                                      .trim()}
                                </div>
                              </div>

                              {businessUnitData.map((businessUnit, index) => (
                                <>
                                  <div className="border-bottom border-end width-70   text-center pt-2">
                                    {segment?.businessUnitPurchasePrice?.[
                                      businessUnit?.id
                                    ] && (
                                      <>
                                        ISK{" "}
                                        {currencyFormatter
                                          .format(
                                            segment.businessUnitPurchasePrice[
                                              businessUnit?.id
                                            ],
                                            {
                                              code: "ISK",
                                            }
                                          )
                                          .replace("kr.", "")
                                          .trim()}
                                      </>
                                    )}
                                  </div>
                                  <div className="border-bottom border-end width-70   text-center pt-2">
                                    {segment?.businessUnitPurchasePrice?.[
                                      businessUnit?.id
                                    ] && (
                                      <>
                                        {(
                                          (segment.businessUnitPurchasePrice[
                                            businessUnit?.id
                                          ] /
                                            businessUnitTotalPurchasePrice
                                              ?.grandTotal?.[
                                              businessUnit?.id
                                            ]) *
                                          100
                                        ).toFixed(2) + "%"}
                                      </>
                                    )}
                                  </div>
                                  <div
                                    className="border-bottom border-end width-70 text-center pt-2"
                                    title={
                                      segment?.businessUnitPurchasePrice?.[
                                        businessUnit?.id
                                      ]
                                        ? `Total Base Units ${
                                            segment.baseUnitList?.[
                                              businessUnit?.id
                                            ]
                                          }`
                                        : ""
                                    }
                                  >
                                    {segment?.baseUnitList?.[
                                      businessUnit?.id
                                    ] ? (
                                      <>
                                        ISK{" "}
                                        {segment?.baseUnitList &&
                                          currencyFormatter
                                            .format(
                                              segment.businessUnitPurchasePrice[
                                                businessUnit?.id
                                              ] /
                                                Math.max(
                                                  segment.baseUnitList[
                                                    businessUnit?.id
                                                  ] || 0,
                                                  1
                                                ), // Prevent division by zero
                                              { code: "ISK" }
                                            )
                                            .replace("kr.", "")
                                            .trim()}
                                      </>
                                    ) : segment?.businessUnitPurchasePrice?.[
                                        businessUnit?.id
                                      ] ? (
                                      <>
                                        ISK{" "}
                                        {currencyFormatter
                                          .format(
                                            segment.businessUnitPurchasePrice[
                                              businessUnit?.id
                                            ],
                                            {
                                              code: "ISK",
                                            }
                                          )
                                          .replace("kr.", "")
                                          .trim()}
                                      </>
                                    ) : null}
                                  </div>
                                </>
                              ))}
                            </div>

                            {/* Family List */}
                            <div
                              className="collapse"
                              id={`segment-${segmentIndex}`}
                            >
                              {/* Segment Products List Start */}

                              {segment?.products.length > 0 && (
                                <>
                                  <div
                                    className="d-flex border color-product"
                                    style={{
                                      width: `${
                                        (businessUnitData.length + 1) * 210 +
                                        160
                                      }px`,
                                    }}
                                  >
                                    <div className="border classification-name fixed-column">
                                      <button
                                        className="segment-btn color-product ps-2"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#segmentProducts-${segmentIndex}`}
                                        aria-expanded="false"
                                        aria-controls={`segmentProducts-${segmentIndex}`}
                                        onClick={() =>
                                          toggleSegment(
                                            "segmentProducts-" + segmentIndex
                                          )
                                        }
                                        title="List of Products which belongs to this Segment"
                                      >
                                        {expandedElementIds.includes(
                                          "segmentProducts-" + segmentIndex
                                        ) ? (
                                          <i className="fa-solid fa-minus me-1"></i>
                                        ) : (
                                          <i className="fa-solid fa-plus me-1"></i>
                                        )}
                                        {(() => {
                                          return `Segment Products (${segment?.products.length})`;
                                        })()}
                                      </button>
                                    </div>
                                    <div className="fixed-column-2 d-flex">
                                      <div className="border width-70   text-center pt-2">
                                        ISK{" "}
                                        {segment?.productsPurchasePrice
                                          ? currencyFormatter
                                              .format(
                                                segment.productsPurchasePrice,
                                                {
                                                  code: "ISK",
                                                }
                                              )
                                              .replace("kr.", "")
                                              .trim()
                                          : 0}
                                      </div>
                                      <div
                                        className="border width-70   text-center pt-2"
                                        title={
                                          segment?.productsPurchasePrice > 0
                                            ? (
                                                (Number(
                                                  segment?.productsPurchasePrice
                                                ) /
                                                  grandTotalPurchaseAmountCombined) *
                                                100
                                              ).toFixed(5) + "%"
                                            : "-"
                                        }
                                      >
                                        {segment?.productsPurchasePrice > 0
                                          ? (
                                              (Number(
                                                segment?.productsPurchasePrice
                                              ) /
                                                grandTotalPurchaseAmountCombined) *
                                              100
                                            ).toFixed(2) + "%"
                                          : "-"}
                                      </div>
                                      <div className="border width-70   text-center pt-2">
                                        {/* {segment?.purchasePrice > 0
                                          ? (
                                            <>
                                            ISK{" "}
                                            {segment?.purchasePrice
                                              ? currencyFormatter
                                                  .format(
                                                    (segment.purchasePrice / segment.baseUnit),
                                                    {
                                                      code: "ISK",
                                                    }
                                                  )
                                                  .replace("kr.", "")
                                                  .trim()
                                                  : 0}
                                                  </>
                                            )
                                          : ""} */}
                                      </div>
                                    </div>

                                    {businessUnitData.map(
                                      (businessUnit, index) =>
                                        businessUnit?.id ===
                                        segment?.products[0]?.businessUnitId ? (
                                          <>
                                            <div className="border width-70   text-center pt-2">
                                              ISK{" "}
                                              {segment?.products
                                                ? currencyFormatter
                                                    .format(
                                                      segment.products.reduce(
                                                        (acc, product) => {
                                                          if (
                                                            product.purchasePrice
                                                          ) {
                                                            return (
                                                              Number(acc) +
                                                              Number(
                                                                product.purchasePrice
                                                              )
                                                            );
                                                          }
                                                          return acc;
                                                        },
                                                        0
                                                      ),
                                                      {
                                                        code: "ISK",
                                                      }
                                                    )
                                                    .replace("kr.", "")
                                                    .trim()
                                                : 0}
                                            </div>
                                            <div className="border width-70   text-center pt-2">
                                              {segment?.products.length > 0
                                                ? (
                                                    (segment.products.reduce(
                                                      (acc, product) => {
                                                        if (
                                                          product.purchasePrice
                                                        ) {
                                                          return (
                                                            Number(acc) +
                                                            Number(
                                                              product.purchasePrice
                                                            )
                                                          );
                                                        }
                                                        return acc;
                                                      },
                                                      0
                                                    ) /
                                                      grandTotalPurchaseAmountCombined) *
                                                    100
                                                  ).toFixed(2) + "%"
                                                : "-"}
                                            </div>
                                            <div className="border width-70   text-center pt-2"></div>
                                          </>
                                        ) : (
                                          <>
                                            <div className="border width-70   text-center pt-2"></div>
                                            <div className="border width-70   text-center pt-2"></div>
                                            <div className="border width-70   text-center pt-2"></div>
                                          </>
                                        )
                                    )}
                                  </div>
                                </>
                              )}

                              {/* Segment Products List */}
                              <div
                                className="collapse"
                                id={`segmentProducts-${segmentIndex}`}
                              >
                                {segment?.products &&
                                  segment?.products.map(
                                    (segmentProduct, segmentProductIndex) => (
                                      <>
                                        {/* {segmentProduct.pastOrder && ( */}
                                        <div
                                          className="d-flex border color-product"
                                          style={{
                                            width: `${
                                              (businessUnitData.length + 1) *
                                                210 +
                                              160
                                            }px`,
                                          }}
                                        >
                                          <div className="border classification-name fixed-column">
                                            <button
                                              className="segment-btn color-product ps-3 text-url"
                                              type="button"
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#segmentProduct${segmentProductIndex}`}
                                              aria-expanded="false"
                                              aria-controls={`segmentProduct${segmentProductIndex}`}
                                              // onClick={() =>
                                              //   getPurchaseHistory(
                                              //     segmentProduct.id,
                                              //     segmentProduct.pastOrder
                                              //       .invoiceId
                                              //   )
                                              // }
                                              onClick={() =>
                                                getPurchaseHistoryByProductId(
                                                  segmentProduct.productId
                                                )
                                              }
                                              title={segmentProduct.unspscTitle}
                                            >
                                              <i className="fa-solid fa-up-right-from-square me-1"></i>
                                              {segmentProduct?.unspscTitle
                                                .length > 18
                                                ? segmentProduct.unspscTitle.slice(
                                                    0,
                                                    18
                                                  ) + "..."
                                                : segmentProduct.unspscTitle}
                                            </button>
                                          </div>
                                          <div className="fixed-column-2 d-flex">
                                            <div className="border width-70   text-center pt-2">
                                              ISK{" "}
                                              {currencyFormatter
                                                .format(
                                                  segmentProduct.purchasePrice,
                                                  {
                                                    code: "ISK",
                                                  }
                                                )
                                                .replace("kr.", "")
                                                .trim()}
                                            </div>
                                            <div
                                              className="border width-70   text-center pt-2"
                                              title={
                                                segmentProduct?.purchasePrice &&
                                                grandTotalPurchaseAmountCombined
                                                  ? (
                                                      (Number(
                                                        segmentProduct.purchasePrice
                                                      ) /
                                                        grandTotalPurchaseAmountCombined) *
                                                      100
                                                    ).toFixed(5) + "%"
                                                  : "-"
                                              }
                                            >
                                              {segmentProduct?.purchasePrice &&
                                              grandTotalPurchaseAmountCombined
                                                ? (
                                                    (Number(
                                                      segmentProduct.purchasePrice
                                                    ) /
                                                      grandTotalPurchaseAmountCombined) *
                                                    100
                                                  ).toFixed(2) + "%"
                                                : "-"}
                                            </div>
                                            <div className="border width-70   text-center pt-2">
                                              {segmentProduct?.purchasePrice &&
                                              segmentProduct?.baseUnit
                                                ? (
                                                    Number(
                                                      segmentProduct.purchasePrice
                                                    ) /
                                                    (segmentProduct.baseUnit > 0
                                                      ? Number(
                                                          segmentProduct.baseUnit
                                                        )
                                                      : 1)
                                                  ).toFixed(2)
                                                : "-"}
                                            </div>
                                          </div>
                                          {businessUnitData.map(
                                            (businessUnit, index) =>
                                              segmentProduct?.businessUnitId ===
                                              businessUnit.id ? (
                                                <React.Fragment key={index}>
                                                  <div className="border width-70   text-center pt-2">
                                                    ISK{" "}
                                                    {segmentProduct?.purchasePrice
                                                      ? currencyFormatter
                                                          .format(
                                                            segmentProduct.purchasePrice,
                                                            {
                                                              code: "ISK",
                                                            }
                                                          )
                                                          .replace("kr.", "")
                                                          .trim()
                                                      : 0}
                                                  </div>
                                                  <div className="border width-70   text-center pt-2">
                                                    {Number(
                                                      segmentProduct.purchasePrice
                                                    ) &&
                                                    grandTotalPurchaseAmountCombined
                                                      ? (
                                                          (Number(
                                                            segmentProduct.purchasePrice
                                                          ) /
                                                            grandTotalPurchaseAmountCombined) *
                                                          100
                                                        ).toFixed(2) + "%"
                                                      : "-"}
                                                  </div>
                                                  <div className="border width-70   text-center pt-2">
                                                    {segmentProduct.purchasePrice &&
                                                    segmentProduct.baseUnit
                                                      ? (
                                                          Number(
                                                            segmentProduct.purchasePrice
                                                          ) /
                                                          (segmentProduct.baseUnit >
                                                          0
                                                            ? Number(
                                                                segmentProduct.baseUnit
                                                              )
                                                            : 1)
                                                        ).toFixed(2)
                                                      : "-"}
                                                  </div>
                                                  {/* <div className="border width-70   text-center pt-2">
                                                                    {product.purchasePrice ||
                                                                      ""}
                                                                  </div> */}
                                                </React.Fragment>
                                              ) : (
                                                <React.Fragment key={index}>
                                                  <div className="border width-70   text-center pt-2"></div>
                                                  <div className="border width-70   text-center pt-2"></div>
                                                  <div className="border width-70   text-center pt-2"></div>
                                                  {/* <div className="border width-70   text-center pt-2"></div> */}
                                                </React.Fragment>
                                              )
                                          )}
                                        </div>
                                        {/* )} */}
                                      </>
                                    )
                                  )}
                              </div>

                              {/* Segment Products List End */}

                              {/* Family Report Start*/}
                              {segment?.families &&
                                segment.families.map((family, familyIndex) => (
                                  <>
                                    <div
                                      className="d-flex  color-family"
                                      style={{
                                        width: `${
                                          (businessUnitData.length + 1) * 210 +
                                          160
                                        }px`,
                                      }}
                                    >
                                      <div className="border-bottom border-end border-start classification-name fixed-column">
                                        <button
                                          className="segment-btn color-family ps-2"
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target={`#family-${
                                            segmentIndex + "-" + familyIndex
                                          }`}
                                          aria-expanded="false"
                                          aria-controls={`family-${
                                            segmentIndex + "-" + familyIndex
                                          }`}
                                          onClick={() =>
                                            toggleSegment(
                                              "family-" +
                                                segmentIndex +
                                                "-" +
                                                familyIndex
                                            )
                                          }
                                          title={family.FamilyTitle}
                                        >
                                          {expandedElementIds.includes(
                                            "family-" +
                                              segmentIndex +
                                              "-" +
                                              familyIndex
                                          ) ? (
                                            <i className="fa-solid fa-minus me-1"></i>
                                          ) : (
                                            <i className="fa-solid fa-plus me-1"></i>
                                          )}
                                          {family?.FamilyTitle
                                            ? family?.FamilyTitle.length > 18
                                              ? family.FamilyTitle.slice(
                                                  0,
                                                  18
                                                ) + "..."
                                              : family.FamilyTitle
                                            : ""}
                                        </button>
                                      </div>
                                      <div className="fixed-column-2 d-flex">
                                        <div className="border-bottom border-end  width-70   text-center pt-2">
                                          ISK{" "}
                                          {family?.businessUnitPurchasePrice &&
                                            currencyFormatter
                                              .format(
                                                Object.values(
                                                  family.businessUnitPurchasePrice
                                                ).reduce((acc, value) => {
                                                  return acc + value;
                                                }, 0),
                                                {
                                                  code: "ISK",
                                                }
                                              )
                                              .replace("kr.", "")
                                              .trim()}
                                        </div>
                                        <div
                                          className="border-bottom border-end  width-70   text-center pt-2"
                                          title={
                                            (
                                              (family.purchasePriceTotal /
                                                grandTotalPurchaseAmountCombined) *
                                              100
                                            ).toFixed(5) + "%" || ""
                                          }
                                        >
                                          {(
                                            (family.purchasePriceTotal /
                                              grandTotalPurchaseAmountCombined) *
                                            100
                                          ).toFixed(2) + "%" || ""}
                                        </div>
                                        <div
                                          className="border-bottom border-end width-70 text-center pt-2"
                                          title={
                                            `Total Base Units ${Object.values(
                                              family.baseUnitList
                                            ).reduce(
                                              (acc, value) => acc + value,
                                              0
                                            )}` || ""
                                          }
                                        >
                                          ISK{" "}
                                          {family?.baseUnitList &&
                                            currencyFormatter
                                              .format(
                                                Object.values(
                                                  family.businessUnitPurchasePrice ||
                                                    {}
                                                ).reduce(
                                                  (acc, value) => acc + value,
                                                  0
                                                ) /
                                                  Math.max(
                                                    Object.values(
                                                      family.baseUnitList || {}
                                                    ).reduce(
                                                      (acc, value) =>
                                                        acc + value,
                                                      0
                                                    ),
                                                    1 // Prevent division by zero
                                                  ),
                                                {
                                                  code: "ISK",
                                                }
                                              )
                                              .replace("kr.", "")
                                              .trim()}
                                        </div>
                                      </div>

                                      {businessUnitData.map(
                                        (businessUnit, index) => (
                                          <>
                                            <div className="border-bottom border-end width-70 text-center pt-2">
                                              {family
                                                ?.businessUnitPurchasePrice?.[
                                                businessUnit?.id
                                              ] && (
                                                <>
                                                  ISK{" "}
                                                  {currencyFormatter
                                                    .format(
                                                      family
                                                        .businessUnitPurchasePrice[
                                                        businessUnit?.id
                                                      ],
                                                      {
                                                        code: "ISK",
                                                      }
                                                    )
                                                    .replace("kr.", "")
                                                    .trim()}
                                                </>
                                              )}
                                            </div>
                                            <div className="border-bottom border-end width-70 text-center pt-2">
                                              {family
                                                ?.businessUnitPurchasePrice?.[
                                                businessUnit?.id
                                              ] && (
                                                <>
                                                  {(
                                                    (family
                                                      .businessUnitPurchasePrice[
                                                      businessUnit?.id
                                                    ] /
                                                      businessUnitTotalPurchasePrice
                                                        ?.grandTotal?.[
                                                        businessUnit?.id
                                                      ]) *
                                                    100
                                                  ).toFixed(2) + "%"}
                                                </>
                                              )}
                                            </div>
                                            <div
                                              className="border-bottom border-end width-70 text-center pt-2"
                                              title={
                                                family
                                                  ?.businessUnitPurchasePrice?.[
                                                  businessUnit?.id
                                                ]
                                                  ? `Total Base Units ${
                                                      family.baseUnitList?.[
                                                        businessUnit?.id
                                                      ]
                                                    }`
                                                  : ""
                                              }
                                            >
                                              {family?.baseUnitList?.[
                                                businessUnit?.id
                                              ] ? (
                                                <>
                                                  ISK{" "}
                                                  {family?.baseUnitList &&
                                                    currencyFormatter
                                                      .format(
                                                        family
                                                          .businessUnitPurchasePrice[
                                                          businessUnit?.id
                                                        ] /
                                                          Math.max(
                                                            family.baseUnitList[
                                                              businessUnit?.id
                                                            ] || 0,
                                                            1
                                                          ), // Prevent division by zero
                                                        { code: "ISK" }
                                                      )
                                                      .replace("kr.", "")
                                                      .trim()}
                                                </>
                                              ) : family
                                                  ?.businessUnitPurchasePrice?.[
                                                  businessUnit?.id
                                                ] ? ( // Fixed the misplaced colon `{ : }`
                                                <>
                                                  ISK{" "}
                                                  {currencyFormatter
                                                    .format(
                                                      family
                                                        .businessUnitPurchasePrice[
                                                        businessUnit?.id
                                                      ],
                                                      {
                                                        code: "ISK",
                                                      }
                                                    )
                                                    .replace("kr.", "")
                                                    .trim()}
                                                </>
                                              ) : null}
                                            </div>
                                          </>
                                        )
                                      )}
                                    </div>

                                    {/* Class List */}
                                    <div
                                      className="collapse"
                                      id={`family-${
                                        segmentIndex + "-" + familyIndex
                                      }`}
                                    >
                                      {/* Family Products List Start */}
                                      {family?.products.length > 0 && (
                                        <>
                                          <div
                                            className="d-flex border-bottom color-product"
                                            style={{
                                              width: `${
                                                (businessUnitData.length + 1) *
                                                  210 +
                                                160
                                              }px`,
                                            }}
                                          >
                                            <div className="border-start border-end classification-name fixed-column">
                                              <button
                                                className="segment-btn color-product ps-3"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#familyProducts-${familyIndex}`}
                                                aria-expanded="false"
                                                aria-controls={`familyProducts-${familyIndex}`}
                                                onClick={() =>
                                                  toggleSegment(
                                                    "familyProducts-" +
                                                      familyIndex
                                                  )
                                                }
                                                title="List of Products which belongs to this Segment"
                                              >
                                                {expandedElementIds.includes(
                                                  "familyProducts-" +
                                                    familyIndex
                                                ) ? (
                                                  <i className="fa-solid fa-minus me-1"></i>
                                                ) : (
                                                  <i className="fa-solid fa-plus me-1"></i>
                                                )}
                                                {(() => {
                                                  const familyProductCountWithPastOrder =
                                                    family?.products
                                                      ? family?.products.length
                                                      : 0;
                                                  return `Family Products (${familyProductCountWithPastOrder})`;
                                                })()}
                                              </button>
                                            </div>
                                            <div className="fixed-column-2 d-flex">
                                              <div className="border-end width-70   text-center pt-2">
                                                ISK{" "}
                                                {currencyFormatter
                                                  .format(
                                                    family?.productsPurchasePrice,
                                                    {
                                                      code: "ISK",
                                                    }
                                                  )
                                                  .replace("kr.", "")
                                                  .trim()}
                                              </div>
                                              <div className="border-end width-70   text-center pt-2">
                                                {family?.products.length > 0
                                                  ? (
                                                      (family.products.reduce(
                                                        (acc, product) => {
                                                          if (
                                                            product.purchasePrice
                                                          ) {
                                                            return (
                                                              Number(acc) +
                                                              Number(
                                                                product.purchasePrice
                                                              )
                                                            );
                                                          }
                                                          return acc;
                                                        },
                                                        0
                                                      ) /
                                                        grandTotalPurchaseAmountCombined) *
                                                      100
                                                    ).toFixed(2) + "%"
                                                  : "-"}
                                              </div>
                                              <div className="border-end width-70   text-center pt-2">
                                                {family?.productsPurchasePrice >
                                                0 ? (
                                                  <>
                                                    ISK{" "}
                                                    {currencyFormatter
                                                      .format(
                                                        Number(
                                                          family?.productsPurchasePrice
                                                        ) 
                                                        // /
                                                          // Math.max(
                                                          //   family?.products?.reduce(
                                                          //     (acc, product) =>
                                                          //       acc +
                                                          //       (product.baseUnit ||
                                                          //         0),
                                                          //     0
                                                          //   ),
                                                          //   1
                                                          // )
/
                                                          Math.max(
                                                            family?.products?.reduce(
                                                              (acc, product) => acc + (Number(product.baseUnit) || 0), // Ensures numeric conversion
                                                              0
                                                            ) || 0, // Prevents reduce() from returning undefined
                                                            1 // Ensures the minimum value is 1
                                                          )
                                                        ,
                                                        {
                                                          code: "ISK",
                                                        }
                                                      )
                                                      .replace("kr.", "")
                                                      .trim()}
                                                  </>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </div>

                                            {businessUnitData.map(
                                              (businessUnit, index) => (
                                                <>
                                                  <div className="border-end width-70   text-center pt-2">
                                                    {family?.products
                                                      ? (() => {
                                                          const total =
                                                            family.products.reduce(
                                                              (
                                                                acc,
                                                                product
                                                              ) => {
                                                                if (
                                                                  product.businessUnitId ===
                                                                  businessUnit.id
                                                                ) {
                                                                  return (
                                                                    Number(
                                                                      acc
                                                                    ) +
                                                                    Number(
                                                                      product.purchasePrice
                                                                    )
                                                                  );
                                                                }
                                                                return acc;
                                                              },
                                                              0
                                                            );

                                                          return total > 0
                                                            ? "ISK " +
                                                                currencyFormatter
                                                                  .format(
                                                                    total,
                                                                    {
                                                                      code: "ISK",
                                                                    }
                                                                  )
                                                                  .replace(
                                                                    "kr.",
                                                                    ""
                                                                  )
                                                                  .trim()
                                                            : "";
                                                        })()
                                                      : ""}
                                                  </div>
                                                  <div className="border-end width-70 text-center pt-2">

                                                  {
  family?.products
    ? (() => {
        const total = family.products.reduce(
          (acc, product) =>
            product.businessUnitId === businessUnit.id
              ? acc + Number(product.purchasePrice)
              : acc,
          0
        );

        return total > 0
          ? 
          ((total / businessUnitTotalPurchasePrice?.grandTotal[businessUnit?.id]) * 100).toFixed(2)+'%'
               
          : "";
      })()
    : ""
}



                                                  </div>
                                                  <div className="border-end width-70 text-center pt-2">
                                                  {
  family?.products
    ? (() => {
        const total = family.products.reduce(
          (acc, product) =>
            product.businessUnitId === businessUnit.id
              ? acc + Number(product.purchasePrice)
              : acc,
          0
        );

        const baseUnit = family.products.reduce(
          (acc, product) =>
            product.businessUnitId === businessUnit.id
              ? acc + Number(product.baseUnit)
              : acc,
          0
        );

        return total > 0
          ? "ISK " +
              currencyFormatter
                .format(total / (baseUnit > 0 ? baseUnit : 1), { code: "ISK" })
                .replace("kr.", "")
                .trim()
          : "";
      })()
    : ""
}




                                                  </div>
                                                </>
                                              )
                                            )}
                                          </div>
                                        </>
                                      )}

                                      {/* Family Products List */}
                                      <div
                                        className="collapse"
                                        id={`familyProducts-${familyIndex}`}
                                      >
                                        {family?.products &&
                                          family?.products.map(
                                            (
                                              familyProduct,
                                              familyProductIndex
                                            ) => (
                                              <>
                                                {/* {familyProduct.pastOrder && ( */}
                                                <div
                                                  className="d-flex border-bottom color-product"
                                                  style={{
                                                    width: `${
                                                      (businessUnitData.length +
                                                        1) *
                                                        210 +
                                                      160
                                                    }px`,
                                                  }}
                                                >
                                                  <div className="border-start border-end classification-name fixed-column">
                                                    <button
                                                      className="segment-btn color-product ps-3 text-url"
                                                      type="button"
                                                      data-bs-toggle="collapse"
                                                      data-bs-target={`#familyProduct${familyProductIndex}`}
                                                      aria-expanded="false"
                                                      aria-controls={`familyProduct${familyProductIndex}`}
                                                      // onClick={() =>
                                                      //   getPurchaseHistory(
                                                      //     familyProduct.id,
                                                      //     familyProduct
                                                      //       .pastOrder
                                                      //       .invoiceId
                                                      //   )
                                                      // }
                                                      onClick={() =>
                                                        getPurchaseHistoryByProductId(
                                                          familyProduct.productId
                                                        )
                                                      }
                                                      title={
                                                        familyProduct.unspscTitle
                                                      }
                                                    >
                                                      <i className="fa-solid fa-up-right-from-square me-1"></i>
                                                      {familyProduct
                                                        ?.unspscTitle.length >
                                                      18
                                                        ? familyProduct.unspscTitle.slice(
                                                            0,
                                                            18
                                                          ) + "..."
                                                        : familyProduct.unspscTitle}
                                                    </button>
                                                  </div>
                                                  <div className="fixed-column-2 d-flex">
                                                    <div className="border-end width-70   text-center pt-2">
                                                      {/* {familyProduct.purchasePrice.toFixed(
                                                                2
                                                              )} */}
                                                      {/* {formatISK(
                                                                familyProduct.purchasePrice
                                                              ) || ""} */}
                                                      ISK{" "}
                                                      {currencyFormatter
                                                        .format(
                                                          familyProduct.purchasePrice,
                                                          {
                                                            code: "ISK",
                                                          }
                                                        )
                                                        .replace("kr.", "")
                                                        .trim()}
                                                    </div>
                                                    <div
                                                      className="border-end width-70   text-center pt-2"
                                                      title={
                                                        Number(
                                                          familyProduct.purchasePrice
                                                        ) &&
                                                        grandTotalPurchaseAmountCombined
                                                          ? (
                                                              (Number(
                                                                familyProduct.purchasePrice
                                                              ) /
                                                                grandTotalPurchaseAmountCombined) *
                                                              100
                                                            ).toFixed(5) + "%"
                                                          : "-"
                                                      }
                                                    >
                                                      {Number(
                                                        familyProduct.purchasePrice
                                                      ) &&
                                                      grandTotalPurchaseAmountCombined
                                                        ? (
                                                            (Number(
                                                              familyProduct.purchasePrice
                                                            ) /
                                                              grandTotalPurchaseAmountCombined) *
                                                            100
                                                          ).toFixed(2) + "%"
                                                        : "-"}
                                                    </div>
                                                    <div className="border-end width-70   text-center pt-2">
                                                    {
  familyProduct.purchasePrice && familyProduct.baseUnit
    ? "ISK " +
        currencyFormatter
          .format(
            Number(familyProduct.purchasePrice) /
              (familyProduct.baseUnit > 0 ? Number(familyProduct.baseUnit) : 1),
            { code: "ISK" }
          )
          .replace("kr.", "")
          .trim()
    : "-"
}

                                                    </div>
                                                  </div>
                                                  {businessUnitData.map(
                                                    (businessUnit, index) =>
                                                      familyProduct?.businessUnitId ===
                                                      businessUnit.id ? (
                                                        <React.Fragment
                                                          key={index}
                                                        >
                                                          <div className="border-end width-70   text-center pt-2">
                                                            ISK{" "}
                                                            {currencyFormatter
                                                              .format(
                                                                familyProduct.purchasePrice,
                                                                {
                                                                  code: "ISK",
                                                                }
                                                              )
                                                              .replace(
                                                                "kr.",
                                                                ""
                                                              )
                                                              .trim()}
                                                          </div>
                                                          <div
                                                            className="border-end width-70   text-center pt-2"
                                                            title={
                                                              Number(
                                                                familyProduct.purchasePrice
                                                              ) &&
                                                              businessUnitTotalPurchasePrice?.grandTotal[businessUnit?.id]
                                                                ? (
                                                                    (Number(
                                                                      familyProduct.purchasePrice
                                                                    ) /
                                                                      businessUnitTotalPurchasePrice?.grandTotal[businessUnit?.id]) *
                                                                    100
                                                                  ).toFixed(2) +
                                                                  "%"
                                                                : "-"
                                                            }
                                                          >
                                                            {Number(
                                                              familyProduct.purchasePrice
                                                            ) &&
                                                            businessUnitTotalPurchasePrice?.grandTotal[businessUnit?.id]
                                                              ? (
                                                                  (Number(
                                                                    familyProduct.purchasePrice
                                                                  ) /
                                                                    businessUnitTotalPurchasePrice?.grandTotal[businessUnit?.id]) *
                                                                  100
                                                                ).toFixed(2) +
                                                                "%"
                                                              : "-"}
                                                          </div>
                                                          <div className="border-end width-70   text-center pt-2">
                                                            {familyProduct.purchasePrice &&
                                                            familyProduct.baseUnit
                                                              ? "ISK " +
                                                                currencyFormatter
                                                                  .format(
                                                                    Number(
                                                                      familyProduct.purchasePrice
                                                                    ) /
                                                                      (Number(
                                                                        familyProduct.baseUnit
                                                                      ) > 0
                                                                        ? Number(
                                                                            familyProduct.baseUnit
                                                                          )
                                                                        : 1),
                                                                    {
                                                                      code: "ISK",
                                                                    } // Keeping this as requested
                                                                  )
                                                                  .replace(
                                                                    "kr.",
                                                                    ""
                                                                  )
                                                                  .trim()
                                                              : "-"}
                                                          </div>
                                                        </React.Fragment>
                                                      ) : (
                                                        <React.Fragment
                                                          key={index}
                                                        >
                                                          <div className="border-end width-70   text-center pt-2"></div>
                                                          <div className="border-end width-70   text-center pt-2"></div>
                                                          <div className="border-end width-70   text-center pt-2"></div>
                                                        </React.Fragment>
                                                      )
                                                  )}
                                                </div>
                                                {/* )} */}
                                              </>
                                            )
                                          )}
                                      </div>

                                      {/* Family Products List End */}
                                      {family?.classes &&
                                        family?.classes.map(
                                          (familyClass, familyClassIndex) => (
                                            <>
                                              {/* Class List Start */}
                                              <div
                                                className="d-flex border-bottom color-class"
                                                style={{
                                                  width: `${
                                                    (businessUnitData.length +
                                                      1) *
                                                      210 +
                                                    160
                                                  }px`,
                                                }}
                                              >
                                                <div className="border-start border-end classification-name fixed-column">
                                                  <button
                                                    className="segment-btn color-class ps-3"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#familyClass-${
                                                      segmentIndex +
                                                      "-" +
                                                      familyIndex +
                                                      "-" +
                                                      familyClassIndex
                                                    }`}
                                                    aria-expanded="false"
                                                    aria-controls={`familyClass-${
                                                      segmentIndex +
                                                      "-" +
                                                      familyIndex +
                                                      "-" +
                                                      familyClassIndex
                                                    }`}
                                                    onClick={() =>
                                                      toggleSegment(
                                                        "familyClass-" +
                                                          segmentIndex +
                                                          "-" +
                                                          familyIndex +
                                                          "-" +
                                                          familyClassIndex
                                                      )
                                                    }
                                                    title={
                                                      familyClass?.ClassTitle
                                                    }
                                                  >
                                                    {expandedElementIds.includes(
                                                      "familyClass-" +
                                                        segmentIndex +
                                                        "-" +
                                                        familyIndex +
                                                        "-" +
                                                        familyClassIndex
                                                    ) ? (
                                                      <i className="fa-solid fa-minus me-1"></i>
                                                    ) : (
                                                      <i className="fa-solid fa-plus me-1"></i>
                                                    )}
                                                    {familyClass?.ClassTitle
                                                      .length > 18
                                                      ? familyClass?.ClassTitle.slice(
                                                          0,
                                                          18
                                                        ) + "..."
                                                      : familyClass?.ClassTitle}
                                                  </button>
                                                </div>
                                                <div className="fixed-column-2 d-flex">
                                                  <div className="border-end width-70   text-center pt-2">
                                                    ISK{" "}
                                                    {familyClass?.businessUnitPurchasePrice &&
                                                      currencyFormatter
                                                        .format(
                                                          Object.values(
                                                            familyClass.businessUnitPurchasePrice
                                                          ).reduce(
                                                            (acc, value) => {
                                                              return (
                                                                acc + value
                                                              );
                                                            },
                                                            0
                                                          ) || 0,
                                                          {
                                                            code: "ISK",
                                                          }
                                                        )
                                                        .replace("kr.", "")
                                                        .trim()}
                                                  </div>
                                                  <div
                                                    className=" border-end width-70   text-center pt-2"
                                                    title={
                                                      (
                                                        (familyClass?.purchasePriceTotal /
                                                          grandTotalPurchaseAmountCombined) *
                                                        100
                                                      ).toFixed(5) + "%" || ""
                                                    }
                                                  >
                                                    {(
                                                      (familyClass?.purchasePriceTotal /
                                                        grandTotalPurchaseAmountCombined) *
                                                      100
                                                    ).toFixed(2) + "%" || ""}
                                                  </div>
                                                  <div
                                                    className="border-end width-70 text-center pt-2"
                                                    title={
                                                      `Total Base Units ${Object.values(
                                                        familyClass.baseUnitList
                                                      ).reduce(
                                                        (acc, value) =>
                                                          acc + value,
                                                        0
                                                      )}` || ""
                                                    }
                                                  >
                                                    ISK{" "}
                                                    {familyClass?.baseUnitList &&
                                                      currencyFormatter
                                                        .format(
                                                          Object.values(
                                                            familyClass.businessUnitPurchasePrice ||
                                                              {}
                                                          ).reduce(
                                                            (acc, value) =>
                                                              acc + value,
                                                            0
                                                          ) /
                                                            Math.max(
                                                              Object.values(
                                                                familyClass.baseUnitList ||
                                                                  {}
                                                              ).reduce(
                                                                (acc, value) =>
                                                                  acc + value,
                                                                0
                                                              ),
                                                              1 // Prevent division by zero
                                                            ),
                                                          {
                                                            code: "ISK",
                                                          }
                                                        )
                                                        .replace("kr.", "")
                                                        .trim()}
                                                  </div>
                                                </div>
                                                {businessUnitData.map(
                                                  (businessUnit, index) => (
                                                    <>
                                                      <div className="border-end width-70   text-center pt-2">
                                                        {familyClass
                                                          ?.businessUnitPurchasePrice?.[
                                                          businessUnit?.id
                                                        ] && (
                                                          <>
                                                            ISK{" "}
                                                            {currencyFormatter
                                                              .format(
                                                                familyClass
                                                                  .businessUnitPurchasePrice[
                                                                  businessUnit
                                                                    ?.id
                                                                ],
                                                                {
                                                                  code: "ISK",
                                                                }
                                                              )
                                                              .replace(
                                                                "kr.",
                                                                ""
                                                              )
                                                              .trim()}
                                                          </>
                                                        )}
                                                      </div>
                                                      <div className="border-end width-70   text-center pt-2">
                                                        {familyClass
                                                          ?.businessUnitPurchasePrice?.[
                                                          businessUnit?.id
                                                        ] && (
                                                          <>
                                                            {(
                                                              (familyClass
                                                                .businessUnitPurchasePrice[
                                                                businessUnit?.id
                                                              ] /
                                                                businessUnitTotalPurchasePrice
                                                                  ?.grandTotal?.[
                                                                  businessUnit
                                                                    ?.id
                                                                ]) *
                                                              100
                                                            ).toFixed(2) + "%"}
                                                          </>
                                                        )}
                                                      </div>
                                                      <div
                                                        className="border-end width-70   text-center pt-2"
                                                        title={
                                                          familyClass
                                                            ?.baseUnitList?.[
                                                            businessUnit?.id
                                                          ]
                                                            ? `Total Base Units ${
                                                                familyClass
                                                                  .baseUnitList?.[
                                                                  businessUnit
                                                                    ?.id
                                                                ]
                                                              }`
                                                            : ""
                                                        }
                                                      >
                                                        {familyClass
                                                          ?.baseUnitList?.[
                                                          businessUnit?.id
                                                        ] ? (
                                                          <>
                                                            ISK{" "}
                                                            {familyClass?.baseUnitList &&
                                                              currencyFormatter
                                                                .format(
                                                                  familyClass
                                                                    .businessUnitPurchasePrice[
                                                                    businessUnit
                                                                      ?.id
                                                                  ] /
                                                                    Math.max(
                                                                      familyClass
                                                                        .baseUnitList[
                                                                        businessUnit
                                                                          ?.id
                                                                      ] || 0,
                                                                      1
                                                                    ), // Prevent division by zero
                                                                  {
                                                                    code: "ISK",
                                                                  }
                                                                )
                                                                .replace(
                                                                  "kr.",
                                                                  ""
                                                                )
                                                                .trim()}
                                                          </>
                                                        ) : familyClass
                                                            ?.businessUnitPurchasePrice?.[
                                                            businessUnit?.id
                                                          ] ? (
                                                          <>
                                                            ISK{" "}
                                                            {currencyFormatter
                                                              .format(
                                                                familyClass
                                                                  .businessUnitPurchasePrice[
                                                                  businessUnit
                                                                    ?.id
                                                                ],
                                                                {
                                                                  code: "ISK",
                                                                }
                                                              )
                                                              .replace(
                                                                "kr.",
                                                                ""
                                                              )
                                                              .trim()}
                                                          </>
                                                        ) : null}
                                                      </div>
                                                    </>
                                                  )
                                                )}
                                              </div>
                                              {/* Class List End */}

                                              {/* Commodity list */}
                                              <div
                                                className="collapse"
                                                id={`familyClass-${
                                                  segmentIndex +
                                                  "-" +
                                                  familyIndex +
                                                  "-" +
                                                  familyClassIndex
                                                }`}
                                              >
                                                {/* Class Products List Start */}

                                                {familyClass?.products.length >
                                                  0 && (
                                                  <>
                                                    <div
                                                      className="d-flex border-bottom color-product"
                                                      style={{
                                                        width: `${
                                                          (businessUnitData.length +
                                                            1) *
                                                            210 +
                                                          160
                                                        }px`,
                                                      }}
                                                    >
                                                      <div className="border-start border-end classification-name fixed-column">
                                                        <button
                                                          className="segment-btn color-product ps-4"
                                                          type="button"
                                                          data-bs-toggle="collapse"
                                                          data-bs-target={`#classProducts-${
                                                            segmentIndex +
                                                            "-" +
                                                            familyIndex +
                                                            "-" +
                                                            familyClassIndex
                                                          }`}
                                                          aria-expanded="false"
                                                          aria-controls={`classProducts-${
                                                            segmentIndex +
                                                            "-" +
                                                            familyIndex +
                                                            "-" +
                                                            familyClassIndex
                                                          }`}
                                                          onClick={() =>
                                                            toggleSegment(
                                                              "classProducts-" +
                                                                segmentIndex +
                                                                "-" +
                                                                familyIndex +
                                                                "-" +
                                                                familyClassIndex
                                                            )
                                                          }
                                                          title="List of Products which belongs to this Segment"
                                                        >
                                                          {expandedElementIds.includes(
                                                            "classProducts-" +
                                                              segmentIndex +
                                                              "-" +
                                                              familyIndex +
                                                              "-" +
                                                              familyClassIndex
                                                          ) ? (
                                                            <i className="fa-solid fa-minus me-1"></i>
                                                          ) : (
                                                            <i className="fa-solid fa-plus me-1"></i>
                                                          )}
                                                          {(() => {
                                                            const classProductCountWithPastOrder =
                                                              familyClass
                                                                ?.products
                                                                .length || 0;
                                                            return `Class Products (${classProductCountWithPastOrder})`;
                                                          })()}
                                                        </button>
                                                      </div>
                                                      <div className="fixed-column-2 d-flex">
                                                        <div className="border-end width-70   text-center pt-2">
                                                          ISK{" "}
                                                          {currencyFormatter
                                                            .format(
                                                              familyClass?.products
                                                                ? familyClass.products.reduce(
                                                                    (
                                                                      acc,
                                                                      product
                                                                    ) => {
                                                                      if (
                                                                        product.purchasePrice
                                                                      ) {
                                                                        return (
                                                                          Number(
                                                                            acc
                                                                          ) +
                                                                          Number(
                                                                            product.purchasePrice
                                                                          )
                                                                        );
                                                                      }
                                                                      return acc;
                                                                    },
                                                                    0
                                                                  )
                                                                : 0,
                                                              {
                                                                code: "ISK",
                                                              }
                                                            )
                                                            .replace("kr.", "")
                                                            .trim()}
                                                        </div>
                                                        <div className="border-end width-70   text-center pt-2">
                                                          {familyClass?.products
                                                            .length > 0
                                                            ? (
                                                                (familyClass.products.reduce(
                                                                  (
                                                                    acc,
                                                                    product
                                                                  ) => {
                                                                    if (
                                                                      product.purchasePrice
                                                                    ) {
                                                                      return (
                                                                        Number(
                                                                          acc
                                                                        ) +
                                                                        Number(
                                                                          product.purchasePrice
                                                                        )
                                                                      );
                                                                    }
                                                                    return acc;
                                                                  },
                                                                  0
                                                                ) /
                                                                  grandTotalPurchaseAmountCombined) *
                                                                100
                                                              ).toFixed(2) + "%"
                                                            : "-"}
                                                        </div>
                                                        <div
                                                          className="border-end width-70 text-center pt-2"
                                                          title={`Total Base Units ${familyClass.products.reduce(
                                                            (acc, product) => {
                                                              return (
                                                                acc +
                                                                (product.baseUnit
                                                                  ? Number(
                                                                      product.baseUnit
                                                                    )
                                                                  : 0)
                                                              );
                                                            },
                                                            0
                                                          )}`}
                                                        >
                                                          {familyClass?.products &&
                                                            currencyFormatter
                                                              .format(
                                                                familyClass.products.reduce(
                                                                  (
                                                                    acc,
                                                                    product
                                                                  ) => {
                                                                    return (
                                                                      acc +
                                                                      (product.purchasePrice
                                                                        ? Number(
                                                                            product.purchasePrice
                                                                          )
                                                                        : 0)
                                                                    );
                                                                  },
                                                                  0
                                                                ) /
                                                                  Math.max(
                                                                    familyClass.products.reduce(
                                                                      (
                                                                        acc,
                                                                        product
                                                                      ) => {
                                                                        return (
                                                                          acc +
                                                                          (product.baseUnit
                                                                            ? Number(
                                                                                product.baseUnit
                                                                              )
                                                                            : 0)
                                                                        );
                                                                      },
                                                                      0
                                                                    ),
                                                                    1 // Ensures denominator is never 0
                                                                  ),
                                                                { code: "ISK" }
                                                              )
                                                              .replace(
                                                                "kr.",
                                                                ""
                                                              )
                                                              .trim()}
                                                        </div>
                                                      </div>

                                                      {businessUnitData.map(
                                                        (
                                                          businessUnit,
                                                          index
                                                        ) => (
                                                          <>
                                                            <div className="border-end width-70   text-center pt-2">
                                                              {familyClass?.products
                                                                ? (() => {
                                                                    const total =
                                                                      familyClass.products.reduce(
                                                                        (
                                                                          acc,
                                                                          product
                                                                        ) => {
                                                                          if (
                                                                            product.businessUnitId ===
                                                                            businessUnit.id
                                                                          ) {
                                                                            return (
                                                                              Number(
                                                                                acc
                                                                              ) +
                                                                              Number(
                                                                                product.purchasePrice
                                                                              )
                                                                            );
                                                                          }
                                                                          return acc;
                                                                        },
                                                                        0
                                                                      );

                                                                    return total >
                                                                      0
                                                                      ? "ISK " +
                                                                          currencyFormatter
                                                                            .format(
                                                                              total,
                                                                              {
                                                                                code: "ISK",
                                                                              }
                                                                            )
                                                                            .replace(
                                                                              "kr.",
                                                                              ""
                                                                            )
                                                                            .trim()
                                                                      : "";
                                                                  })()
                                                                : ""}
                                                            </div>
                                                            <div className="border-end width-70 text-center pt-2">
                                                              {familyClass?.products
                                                                ? (() => {
                                                                    const total =
                                                                      familyClass.products.reduce(
                                                                        (
                                                                          acc,
                                                                          product
                                                                        ) => {
                                                                          return product.businessUnitId ===
                                                                            businessUnit.id
                                                                            ? acc +
                                                                                Number(
                                                                                  product.purchasePrice
                                                                                ) ||
                                                                                0
                                                                            : acc;
                                                                        },
                                                                        0
                                                                      );

                                                                    const totalPurchasePrice =
                                                                      Object.values(
                                                                        businessUnitTotalPurchasePrice?.grandTotal ||
                                                                          {}
                                                                      ).reduce(
                                                                        (
                                                                          acc,
                                                                          val
                                                                        ) =>
                                                                          acc +
                                                                          val,
                                                                        0
                                                                      );

                                                                    return total >
                                                                      0 &&
                                                                      totalPurchasePrice >
                                                                        0
                                                                      ? (
                                                                          (total /
                                                                            totalPurchasePrice) *
                                                                          100
                                                                        ).toFixed(
                                                                          2
                                                                        ) + "%"
                                                                      : "";
                                                                  })()
                                                                : ""}
                                                            </div>
                                                            <div className="border-end width-70 text-center pt-2">
                                                              {familyClass?.products
                                                                ? (() => {
                                                                    const total =
                                                                      familyClass.products.reduce(
                                                                        (
                                                                          acc,
                                                                          product
                                                                        ) => {
                                                                          if (
                                                                            product.businessUnitId ===
                                                                            businessUnit.id
                                                                          ) {
                                                                            return (
                                                                              Number(
                                                                                acc
                                                                              ) +
                                                                              Number(
                                                                                product.purchasePrice
                                                                              )
                                                                            );
                                                                          }
                                                                          return acc;
                                                                        },
                                                                        0
                                                                      );

                                                                    const baseUnits =
                                                                      familyClass.products.reduce(
                                                                        (
                                                                          acc,
                                                                          product
                                                                        ) => {
                                                                          if (
                                                                            product.businessUnitId ===
                                                                            businessUnit.id
                                                                          ) {
                                                                            return (
                                                                              Number(
                                                                                acc
                                                                              ) +
                                                                              Number(
                                                                                product.baseUnit
                                                                              )
                                                                            );
                                                                          }
                                                                          return acc;
                                                                        },
                                                                        0
                                                                      );

                                                                    return baseUnits >
                                                                      0 ||
                                                                      total > 0
                                                                      ? "ISK " +
                                                                          currencyFormatter
                                                                            .format(
                                                                              baseUnits >
                                                                                0
                                                                                ? total /
                                                                                    baseUnits
                                                                                : total,
                                                                              {
                                                                                code: "ISK",
                                                                              }
                                                                            )
                                                                            .replace(
                                                                              "kr.",
                                                                              ""
                                                                            )
                                                                            .trim()
                                                                      : "";
                                                                  })()
                                                                : ""}
                                                            </div>
                                                          </>
                                                        )
                                                      )}
                                                    </div>

                                                    {/* Class Products List */}
                                                    <div
                                                      className="collapse"
                                                      id={`classProducts-${
                                                        segmentIndex +
                                                        "-" +
                                                        familyIndex +
                                                        "-" +
                                                        familyClassIndex
                                                      }`}
                                                    >
                                                      {familyClass?.products &&
                                                        familyClass?.products.map(
                                                          (
                                                            classProduct,
                                                            classProductIndex
                                                          ) => (
                                                            <>
                                                              {/* {classProduct.pastOrder && ( */}
                                                              <div
                                                                className="d-flex border-bottom color-product"
                                                                style={{
                                                                  width: `${
                                                                    (businessUnitData.length +
                                                                      1) *
                                                                      210 +
                                                                    160
                                                                  }px`,
                                                                }}
                                                              >
                                                                <div className="border-start border-end classification-name fixed-column">
                                                                  <button
                                                                    className="segment-btn color-product ps-4 text-url"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#classProduct${classProductIndex}`}
                                                                    aria-expanded="false"
                                                                    aria-controls={`classProduct${classProductIndex}`}
                                                                    // onClick={() =>
                                                                    //   getPurchaseHistory(
                                                                    //     classProduct.id,
                                                                    //     classProduct
                                                                    //       .pastOrder
                                                                    //       .invoiceId
                                                                    //   )
                                                                    // }
                                                                    onClick={() =>
                                                                      getPurchaseHistoryByProductId(
                                                                        classProduct.productId
                                                                      )
                                                                    }
                                                                    title={
                                                                      classProduct.unspscTitle
                                                                    }
                                                                  >
                                                                    <i className="fa-solid fa-up-right-from-square me-1"></i>
                                                                    {classProduct
                                                                      ?.unspscTitle
                                                                      .length >
                                                                    18
                                                                      ? classProduct.unspscTitle.slice(
                                                                          0,
                                                                          18
                                                                        ) +
                                                                        "..."
                                                                      : classProduct.unspscTitle}
                                                                  </button>
                                                                </div>
                                                                <div className="fixed-column-2 d-flex">
                                                                  <div className="border-end width-70 text-center pt-2">
                                                                    ISK{" "}
                                                                    {currencyFormatter
                                                                      .format(
                                                                        classProduct.purchasePrice,
                                                                        {
                                                                          code: "ISK",
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        "kr.",
                                                                        ""
                                                                      )
                                                                      .trim()}
                                                                  </div>
                                                                  <div className="border-end width-70 text-center pt-2">
                                                                    {classProduct?.purchasePrice &&
                                                                    grandTotalPurchaseAmountCombined
                                                                      ? (
                                                                          (Number(
                                                                            classProduct?.purchasePrice
                                                                          ) /
                                                                            grandTotalPurchaseAmountCombined) *
                                                                          100
                                                                        ).toFixed(
                                                                          2
                                                                        ) + "%"
                                                                      : "-"}
                                                                  </div>
                                                                  <div className="border-end width-70 text-center pt-2">
                                                                    {classProduct?.purchasePrice &&
                                                                    classProduct?.baseUnit
                                                                      ? (
                                                                          Number(
                                                                            classProduct.purchasePrice
                                                                          ) /
                                                                          Number(
                                                                            classProduct.baseUnit
                                                                          )
                                                                        ).toFixed(
                                                                          2
                                                                        )
                                                                      : "-"}
                                                                  </div>
                                                                </div>
                                                                {businessUnitData.map(
                                                                  (
                                                                    businessUnit,
                                                                    index
                                                                  ) =>
                                                                    classProduct?.businessUnitId ===
                                                                    businessUnit.id ? (
                                                                      <React.Fragment
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        <div className="border-end width-70   text-center pt-2">
                                                                          ISK{" "}
                                                                          {currencyFormatter
                                                                            .format(
                                                                              classProduct.purchasePrice,
                                                                              {
                                                                                code: "ISK",
                                                                              }
                                                                            )
                                                                            .replace(
                                                                              "kr.",
                                                                              ""
                                                                            )
                                                                            .trim()}
                                                                        </div>
                                                                        <div className="border-end width-70   text-center pt-2">
                                                                          {classProduct.purchasePrice &&
                                                                          grandTotalPurchaseAmountCombined
                                                                            ? (
                                                                                (Number(
                                                                                  classProduct.purchasePrice
                                                                                ) /
                                                                                  grandTotalPurchaseAmountCombined) *
                                                                                100
                                                                              ).toFixed(
                                                                                2
                                                                              ) +
                                                                              "%"
                                                                            : "-"}
                                                                        </div>
                                                                        <div className="border-end width-70   text-center pt-2">
                                                                          {classProduct?.purchasePrice &&
                                                                          classProduct?.baseUnit >
                                                                            0
                                                                            ? "ISK " +
                                                                              currencyFormatter
                                                                                .format(
                                                                                  Number(
                                                                                    classProduct.purchasePrice
                                                                                  ) /
                                                                                    (classProduct.baseUnit >
                                                                                    0
                                                                                      ? Number(
                                                                                          classProduct.baseUnit
                                                                                        )
                                                                                      : 1),
                                                                                  {
                                                                                    code: "ISK",
                                                                                  }
                                                                                )
                                                                                .replace(
                                                                                  "kr.",
                                                                                  ""
                                                                                )
                                                                                .trim()
                                                                            : ""}
                                                                        </div>
                                                                      </React.Fragment>
                                                                    ) : (
                                                                      <React.Fragment
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        <div className="border-end width-70   text-center pt-2"></div>
                                                                        <div className="border-end width-70   text-center pt-2"></div>
                                                                        <div className="border-end width-70   text-center pt-2"></div>
                                                                      </React.Fragment>
                                                                    )
                                                                )}
                                                              </div>
                                                              {/* )} */}
                                                            </>
                                                          )
                                                        )}
                                                    </div>
                                                  </>
                                                )}

                                                {/* Class Products List End */}

                                                {familyClass.commodities.map(
                                                  (
                                                    commodity,
                                                    commodityIndex
                                                  ) => (
                                                    <>
                                                      <div
                                                        className="d-flex border-bottom color-commodity"
                                                        style={{
                                                          width: `${
                                                            (businessUnitData.length +
                                                              1) *
                                                              210 +
                                                            160
                                                          }px`,
                                                        }}
                                                      >
                                                        <div className="border-start border-end classification-name fixed-column">
                                                          <button
                                                            className="segment-btn color-commodity ps-4"
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#commodity-${
                                                              segmentIndex +
                                                              "-" +
                                                              familyIndex +
                                                              "-" +
                                                              familyClassIndex +
                                                              "-" +
                                                              commodityIndex
                                                            }`}
                                                            aria-expanded="false"
                                                            aria-controls={`commodity-${
                                                              segmentIndex +
                                                              "-" +
                                                              familyIndex +
                                                              "-" +
                                                              familyClassIndex +
                                                              "-" +
                                                              commodityIndex
                                                            }`}
                                                            onClick={() =>
                                                              toggleSegment(
                                                                "commodity-" +
                                                                  segmentIndex +
                                                                  "-" +
                                                                  familyIndex +
                                                                  "-" +
                                                                  familyClassIndex +
                                                                  "-" +
                                                                  commodityIndex
                                                              )
                                                            }
                                                            title={
                                                              commodity.CommodityTitle
                                                            }
                                                          >
                                                            {expandedElementIds.includes(
                                                              "commodity-" +
                                                                segmentIndex +
                                                                "-" +
                                                                familyIndex +
                                                                "-" +
                                                                familyClassIndex +
                                                                "-" +
                                                                commodityIndex
                                                            ) ? (
                                                              <i className="fa-solid fa-minus me-1"></i>
                                                            ) : (
                                                              <i className="fa-solid fa-plus me-1"></i>
                                                            )}
                                                            {commodity
                                                              ?.CommodityTitle
                                                              .length > 18
                                                              ? commodity.CommodityTitle.slice(
                                                                  0,
                                                                  18
                                                                ) + "..."
                                                              : commodity?.CommodityTitle}
                                                          </button>
                                                        </div>
                                                        <div className="fixed-column-2 d-flex">
                                                          <div className="border-end width-70   text-center pt-2">
                                                            ISK{" "}
                                                            {currencyFormatter
                                                              .format(
                                                                commodity?.purchasePriceTotal,
                                                                {
                                                                  code: "ISK",
                                                                }
                                                              )
                                                              .replace(
                                                                "kr.",
                                                                ""
                                                              )
                                                              .trim()}
                                                          </div>
                                                          <div
                                                            className="border-end width-70   text-center pt-2"
                                                            title={
                                                              (
                                                                (commodity?.purchasePriceTotal /
                                                                  grandTotalPurchaseAmountCombined) *
                                                                100
                                                              ).toFixed(5) +
                                                                "%" || ""
                                                            }
                                                          >
                                                            {(
                                                              (commodity?.purchasePriceTotal /
                                                                grandTotalPurchaseAmountCombined) *
                                                              100
                                                            ).toFixed(2) +
                                                              "%" || ""}
                                                          </div>
                                                          {/* <div className="border-end width-70   text-center pt-2">

                                                            

                                                          




                                                            
                                                          </div> */}

                                                          <div
                                                            className="border-end width-70 text-center pt-2"
                                                            title={`Total Base Units ${Object.values(
                                                              commodity.baseUnitList
                                                            ).reduce(
                                                              (acc, value) =>
                                                                acc + value,
                                                              0
                                                            )}`}
                                                          >
                                                            ISK{" "}
                                                            {commodity?.baseUnitList &&
                                                              currencyFormatter
                                                                .format(
                                                                  Object.values(
                                                                    commodity.businessUnitPurchasePrice
                                                                  ).reduce(
                                                                    (
                                                                      acc,
                                                                      value
                                                                    ) => {
                                                                      return (
                                                                        acc +
                                                                        value
                                                                      );
                                                                    },
                                                                    0
                                                                  ) /
                                                                    (Object.values(
                                                                      commodity.baseUnitList
                                                                    ).reduce(
                                                                      (
                                                                        acc,
                                                                        value
                                                                      ) =>
                                                                        acc +
                                                                        value,
                                                                      0
                                                                    ) || 1),

                                                                  {
                                                                    code: "ISK",
                                                                  }
                                                                )
                                                                .replace(
                                                                  "kr.",
                                                                  ""
                                                                )
                                                                .trim()}
                                                          </div>
                                                        </div>
                                                        {businessUnitData.map(
                                                          (
                                                            businessUnit,
                                                            index
                                                          ) => (
                                                            <>
                                                              <div className="width-70 border-end  text-center pt-2">
                                                                {commodity
                                                                  ?.businessUnitPurchasePrice?.[
                                                                  businessUnit
                                                                    ?.id
                                                                ] && (
                                                                  <>
                                                                    ISK{" "}
                                                                    {currencyFormatter
                                                                      .format(
                                                                        commodity
                                                                          .businessUnitPurchasePrice[
                                                                          businessUnit
                                                                            ?.id
                                                                        ],
                                                                        {
                                                                          code: "ISK",
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        "kr.",
                                                                        ""
                                                                      )
                                                                      .trim()}
                                                                  </>
                                                                )}
                                                              </div>
                                                              <div className="width-70 border-end  text-center pt-2">
                                                                {commodity
                                                                  ?.businessUnitPurchasePrice?.[
                                                                  businessUnit
                                                                    ?.id
                                                                ] && (
                                                                  <>
                                                                    {(
                                                                      (commodity
                                                                        .businessUnitPurchasePrice[
                                                                        businessUnit
                                                                          ?.id
                                                                      ] /
                                                                        businessUnitTotalPurchasePrice
                                                                          ?.grandTotal?.[
                                                                          businessUnit
                                                                            ?.id
                                                                        ]) *
                                                                      100
                                                                    ).toFixed(
                                                                      2
                                                                    ) + "%"}
                                                                  </>
                                                                )}
                                                              </div>
                                                              <div
                                                                className=" width-70 border-end  text-center pt-2"
                                                                title={
                                                                  commodity
                                                                    ?.baseUnitList?.[
                                                                    businessUnit
                                                                      ?.id
                                                                  ]
                                                                    ? `Total Base Units ${
                                                                        commodity
                                                                          .baseUnitList?.[
                                                                          businessUnit
                                                                            ?.id
                                                                        ]
                                                                      }`
                                                                    : ""
                                                                }
                                                              >
                                                                {commodity
                                                                  ?.baseUnitList?.[
                                                                  businessUnit
                                                                    ?.id
                                                                ] ? (
                                                                  <>
                                                                    ISK{" "}
                                                                    {commodity?.baseUnitList &&
                                                                      currencyFormatter
                                                                        .format(
                                                                          commodity
                                                                            .businessUnitPurchasePrice[
                                                                            businessUnit
                                                                              ?.id
                                                                          ] /
                                                                            Math.max(
                                                                              commodity
                                                                                .baseUnitList[
                                                                                businessUnit
                                                                                  ?.id
                                                                              ] ||
                                                                                0,
                                                                              1
                                                                            ), // Prevent division by zero
                                                                          {
                                                                            code: "ISK",
                                                                          }
                                                                        )
                                                                        .replace(
                                                                          "kr.",
                                                                          ""
                                                                        )
                                                                        .trim()}
                                                                  </>
                                                                ) : commodity
                                                                    ?.businessUnitPurchasePrice?.[
                                                                    businessUnit
                                                                      ?.id
                                                                  ] ? (
                                                                  <>
                                                                    ISK{" "}
                                                                    {currencyFormatter
                                                                      .format(
                                                                        commodity
                                                                          .businessUnitPurchasePrice[
                                                                          businessUnit
                                                                            ?.id
                                                                        ],
                                                                        {
                                                                          code: "ISK",
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        "kr.",
                                                                        ""
                                                                      )
                                                                      .trim()}
                                                                  </>
                                                                ) : null}
                                                              </div>
                                                            </>
                                                          )
                                                        )}
                                                      </div>

                                                      {/* Commodity Product List */}
                                                      <div
                                                        className="collapse"
                                                        id={`commodity-${
                                                          segmentIndex +
                                                          "-" +
                                                          familyIndex +
                                                          "-" +
                                                          familyClassIndex +
                                                          "-" +
                                                          commodityIndex
                                                        }`}
                                                      >
                                                        {commodity.products.map(
                                                          (
                                                            product,
                                                            productIndex
                                                          ) => (
                                                            <>
                                                              <div
                                                                className="d-flex border-bottom color-product"
                                                                style={{
                                                                  width: `${
                                                                    (businessUnitData.length +
                                                                      1) *
                                                                      210 +
                                                                    160
                                                                  }px`,
                                                                }}
                                                              >
                                                                <div className="border-start border-end classification-name fixed-column">
                                                                  <button
                                                                    className="segment-btn color-product ps-4 text-url"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#product-${productIndex}`}
                                                                    aria-expanded="false"
                                                                    aria-controls={`product-${productIndex}`}
                                                                    // onClick={() =>
                                                                    //   getPurchaseHistory(
                                                                    //     product.id,
                                                                    //     product
                                                                    //       .pastOrder
                                                                    //       .invoiceId
                                                                    //   )
                                                                    // }
                                                                    onClick={() =>
                                                                      getPurchaseHistoryByProductId(
                                                                        product.productId
                                                                      )
                                                                    }
                                                                    title={
                                                                      product.unspscTitle
                                                                    }
                                                                  >
                                                                    <i className="fa-solid fa-up-right-from-square me-1"></i>
                                                                    {product
                                                                      ?.unspscTitle
                                                                      .length >
                                                                    18
                                                                      ? product?.unspscTitle.slice(
                                                                          0,
                                                                          18
                                                                        ) +
                                                                        "..."
                                                                      : product?.unspscTitle}
                                                                  </button>
                                                                </div>
                                                                <div className="fixed-column-2 d-flex">
                                                                  <div className=" border-end width-70   text-center pt-2">
                                                                    ISK{" "}
                                                                    {currencyFormatter
                                                                      .format(
                                                                        product?.purchasePrice,
                                                                        {
                                                                          code: "ISK",
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        "kr.",
                                                                        ""
                                                                      )
                                                                      .trim()}
                                                                  </div>
                                                                  <div
                                                                    className=" border-end width-70   text-center pt-2"
                                                                    title={
                                                                      product?.purchasePrice &&
                                                                      grandTotalPurchaseAmountCombined
                                                                        ? (
                                                                            (Number(
                                                                              product?.purchasePrice
                                                                            ) /
                                                                              grandTotalPurchaseAmountCombined) *
                                                                            100
                                                                          ).toFixed(
                                                                            5
                                                                          ) +
                                                                          "%"
                                                                        : ""
                                                                    }
                                                                  >
                                                                    {product?.purchasePrice &&
                                                                    grandTotalPurchaseAmountCombined
                                                                      ? (
                                                                          (Number(
                                                                            product?.purchasePrice
                                                                          ) /
                                                                            grandTotalPurchaseAmountCombined) *
                                                                          100
                                                                        ).toFixed(
                                                                          2
                                                                        ) + "%"
                                                                      : ""}
                                                                  </div>
                                                                  <div className=" border-end width-70   text-center pt-2">
                                                                    {product?.purchasePrice &&
                                                                    product?.baseUnit
                                                                      ? `ISK ` +
                                                                        currencyFormatter
                                                                          .format(
                                                                            Number(
                                                                              product.purchasePrice
                                                                            ) /
                                                                              (product?.baseUnit >
                                                                              0
                                                                                ? Number(
                                                                                    product.baseUnit
                                                                                  )
                                                                                : 1),
                                                                            {
                                                                              code: "ISK",
                                                                            }
                                                                          )
                                                                          .replace(
                                                                            "kr.",
                                                                            ""
                                                                          )
                                                                          .trim()
                                                                      : ""}
                                                                  </div>
                                                                </div>
                                                                {businessUnitData.map(
                                                                  (
                                                                    businessUnit,
                                                                    index
                                                                  ) =>
                                                                    product?.businessUnitId ===
                                                                    businessUnit.id ? (
                                                                      <React.Fragment
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        <div className=" border-end width-70   text-center pt-2">
                                                                          ISK{" "}
                                                                          {currencyFormatter
                                                                            .format(
                                                                              product.purchasePrice,
                                                                              {
                                                                                code: "ISK",
                                                                              }
                                                                            )
                                                                            .replace(
                                                                              "kr.",
                                                                              ""
                                                                            )
                                                                            .trim()}
                                                                        </div>
                                                                        {businessUnitTotalPurchasePrice
                                                                          ?.grandTotal[
                                                                          businessUnit
                                                                            ?.id
                                                                        ] &&
                                                                        product?.purchasePrice ? (
                                                                          <>
                                                                            <div
                                                                              className=" border-end width-70   text-center pt-2"
                                                                              title={
                                                                                product?.purchasePrice &&
                                                                                businessUnitTotalPurchasePrice?.grandTotal
                                                                                  ? (
                                                                                      (Number(
                                                                                        product?.purchasePrice
                                                                                      ) /
                                                                                        Object.values(
                                                                                          businessUnitTotalPurchasePrice?.grandTotal
                                                                                        ).reduce(
                                                                                          (
                                                                                            acc,
                                                                                            val
                                                                                          ) =>
                                                                                            acc +
                                                                                            val,
                                                                                          0
                                                                                        )) *
                                                                                      100
                                                                                    ).toFixed(
                                                                                      5
                                                                                    ) +
                                                                                    "%"
                                                                                  : ""
                                                                              }
                                                                            >
                                                                              {product?.purchasePrice &&
                                                                              businessUnitTotalPurchasePrice?.grandTotal
                                                                                ? (
                                                                                    (Number(
                                                                                      product?.purchasePrice
                                                                                    ) /
                                                                                      businessUnitTotalPurchasePrice
                                                                                        ?.grandTotal[
                                                                                        businessUnit
                                                                                          ?.id
                                                                                      ]) *
                                                                                    100
                                                                                  ).toFixed(
                                                                                    2
                                                                                  ) +
                                                                                  "%"
                                                                                : ""}
                                                                            </div>
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            <div className=" border-end width-70   text-center pt-2"></div>
                                                                          </>
                                                                        )}
                                                                        <div className=" border-end width-70   text-center pt-2">
                                                                          {product.purchasePrice &&
                                                                          product.baseUnit
                                                                            ? "ISK " +
                                                                              currencyFormatter
                                                                                .format(
                                                                                  Number(
                                                                                    product.purchasePrice
                                                                                  ) /
                                                                                    (product.baseUnit >
                                                                                    0
                                                                                      ? Number(
                                                                                          product.baseUnit
                                                                                        )
                                                                                      : 1),

                                                                                  {
                                                                                    code: "ISK",
                                                                                  }
                                                                                )
                                                                                .replace(
                                                                                  "kr.",
                                                                                  ""
                                                                                )
                                                                                .trim()
                                                                            : ""}
                                                                        </div>
                                                                      </React.Fragment>
                                                                    ) : (
                                                                      <React.Fragment
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        <div className=" border-end width-70   text-center pt-2"></div>
                                                                        <div className=" border-end width-70   text-center pt-2"></div>
                                                                        <div className=" border-end width-70   text-center pt-2"></div>
                                                                      </React.Fragment>
                                                                    )
                                                                )}
                                                              </div>
                                                            </>
                                                          )
                                                        )}
                                                      </div>
                                                    </>
                                                  )
                                                )}
                                              </div>
                                            </>
                                          )
                                        )}
                                    </div>
                                  </>
                                ))}
                              {/* Family Report End*/}
                            </div>
                          </>
                        ))}

                      {/* Bottom - Total of Classified report */}
                      <div
                        className="d-flex border-bottom"
                        style={{
                          width: `${
                            (businessUnitData.length + 1) * 210 + 160
                          }px`,
                        }}
                      >
                        <div className="border-start border-end classification-name fixed-column">
                          Total
                        </div>
                        <div className="fixed-column-2 d-flex">
                          <div className="border-end width-70   text-center pt-2">
                            ISK{" "}
                            {currencyFormatter
                              .format(grandTotalPurchaseAmount, {
                                code: "ISK",
                              })
                              .replace("kr.", "")
                              .trim()}
                          </div>
                          <div className=" width-70  border-end text-center pt-2">
                            {grandTotalPurchaseAmountCombined &&
                              grandTotalPurchaseAmount &&
                              ((
                                (grandTotalPurchaseAmount /
                                  grandTotalPurchaseAmountCombined) *
                                100
                              ).toFixed(2) + "%" ||
                                "")}
                          </div>
                          <div className=" width-70 border-end  text-center pt-2"></div>
                        </div>

                        {businessUnitData &&
                          businessUnitData.map((businessUnit, index) => (
                            <>
                              <div className=" width-70  border-end  text-center pt-2">
                                ISK{" "}
                                {businessUnitTotalPurchasePrice?.classified?.[
                                  businessUnit.id
                                ]
                                  ? currencyFormatter
                                      .format(
                                        businessUnitTotalPurchasePrice
                                          ?.classified?.[businessUnit.id],
                                        {
                                          code: "ISK",
                                        }
                                      )
                                      .replace("kr.", "")
                                      .trim()
                                  : 0}
                              </div>
                              <div className=" width-70 border-end   text-center pt-2">
                                {businessUnitTotalPurchasePrice?.grandTotal?.[
                                  businessUnit.id
                                ] &&
                                businessUnitTotalPurchasePrice?.classified?.[
                                  businessUnit.id
                                ]
                                  ? (
                                      (businessUnitTotalPurchasePrice
                                        ?.classified?.[businessUnit.id] /
                                        businessUnitTotalPurchasePrice
                                          ?.grandTotal?.[businessUnit.id]) *
                                      100
                                    ).toFixed(2) + "%"
                                  : ""}
                              </div>
                              <div className=" width-70 border-end   text-center pt-2"></div>
                            </>
                          ))}
                      </div>
                    </div>
                  </>
                )}
                {/* Classified Report End*/}

                {/* Unclassified Report Start*/}
                {toggleUnspscReport.includes("unclassifiedReport") && (
                  <div className="mb-5 poSrch ponew mt-5">
                    <h6 className="">Unclassified Report</h6>
                    <div
                      className="report-container"
                      style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                      }}
                    >
                      {/* Heading Start */}
                      <div
                        className="d-flex fixed-header"
                        style={{
                          width: `${
                            (businessUnitData.length + 1) * 210 + 160
                          }px`,
                        }}
                      >
                        <div className="border-top border-start border-end classification-name fixed-column">
                          Product
                        </div>
                        <div className="border-top border-end bUnitName fixed-column-2 pt-1">
                          Total
                        </div>
                        {businessUnitData &&
                          businessUnitData.map((businessUnit, index) => (
                            <div className="border-top border-end bUnitName pt-1">
                              {businessUnit?.name}
                            </div>
                          ))}
                      </div>
                      <div
                        className="border-bottom d-flex fixed-header-2 fw-500"
                        style={{
                          width: `${
                            (businessUnitData.length + 1) * 210 + 160
                          }px`,
                        }}
                      >
                        <div className="border-top border-start border-end classification-name-two fixed-column">
                          Name
                        </div>
                        <div className="fixed-column-2 d-flex">
                          <div
                            className="border-top border-end width-70   text-center pt-2"
                            title="Total Purchase Amount"
                          >
                            Amount
                          </div>
                          <div
                            className="border-top border-end width-70   text-center pt-2"
                            title="Percentage of Total Purchase Amount"
                          >
                            Percentage
                          </div>
                          <div
                            className="border-top border-end width-70   text-center pt-2"
                            title="Average Of Base Unit Price"
                          >
                            Average
                          </div>
                        </div>
                        {businessUnitData &&
                          businessUnitData.map((businessUnit, index) => (
                            <>
                              <div
                                className="border-top border-end width-70 text-center pt-2"
                                title="Total Purchase Amount"
                              >
                                Amount
                              </div>
                              <div
                                className="border-top border-end width-70 text-center pt-2"
                                title="Percentage of Total Purchase Amount"
                              >
                                Percentage
                              </div>
                              <div
                                className="border-top border-end width-70 text-center pt-2"
                                title="Average Of Base Unit Price"
                              >
                                Average
                              </div>
                            </>
                          ))}
                      </div>
                      {/* Heading End */}

                      {unclassifiedProducts &&
                        unclassifiedProducts.map((product, productIndex) => (
                          <>
                            <div
                              className={`d-flex color-product fw-500 ${
                                productIndex !== unclassifiedProducts.length - 1
                                  ? "border-bottom"
                                  : ""
                              }`}
                              // className="d-flex color-product fw-500 border-bottom"
                              style={{
                                width: `${
                                  (businessUnitData.length + 1) * 210 + 160
                                }px`,
                              }}
                            >
                              <div
                                className="border-start border-end classification-name-two fixed-column color-product"
                                title={product.name}
                              >
                                <button
                                  className="segment-btn color-product text-url"
                                  type="button"
                                  onClick={() =>
                                    getPurchaseHistoryByProductId(
                                      product.productId
                                    )
                                  }
                                  title={product.name}
                                >
                                  <i className="fa-solid fa-up-right-from-square me-1"></i>
                                  {product?.name && product?.name.length > 18
                                    ? product.name.slice(0, 18) + "..."
                                    : product.name}
                                </button>
                              </div>
                              <div className="fixed-column-2 d-flex">
                                <div className="border-end width-70   text-center pt-2">
                                  ISK{" "}
                                  {currencyFormatter
                                    .format(product?.purchasePrice, {
                                      code: "ISK",
                                    })
                                    .replace("kr.", "")
                                    .trim()}
                                </div>
                                <div className="border-end width-70   text-center pt-2">
                                  {product?.purchasePrice &&
                                  unclassifiedProductTotalPurchasePrice
                                    ? (
                                        (Number(product?.purchasePrice) /
                                          unclassifiedProductTotalPurchasePrice) *
                                        100
                                      ).toFixed(2) + "%"
                                    : "-"}
                                </div>
                                <div
                                  className="width-70 border-end text-center pt-2"
                                  title={`Total Base Units ${product?.baseUnit}`}
                                >
                                  {product?.purchasePrice &&
                                  product?.baseUnit ? (
                                    <>
                                      ISK{" "}
                                      {currencyFormatter
                                        .format(
                                          Number(product?.purchasePrice) /
                                            (product?.baseUnit > 0
                                              ? Number(product?.baseUnit)
                                              : 1),
                                          {
                                            code: "ISK",
                                          }
                                        )
                                        .replace("kr.", "")
                                        .trim()}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              {businessUnitData &&
                                businessUnitData.map((businessUnit, index) =>
                                  businessUnit?.id ===
                                  product?.businessUnitId ? (
                                    <React.Fragment key={businessUnit.id}>
                                      <div className="border-end width-70   text-center pt-2">
                                        ISK{" "}
                                        {currencyFormatter
                                          .format(product?.purchasePrice, {
                                            code: "ISK",
                                          })
                                          .replace("kr.", "")
                                          .trim()}
                                      </div>
                                      <div className="border-end width-70   text-center pt-2">
                                        {product?.purchasePrice &&
                                        businessUnitTotalPurchasePrice
                                          ?.grandTotal?.[businessUnit?.id]
                                          ? (
                                              (Number(product?.purchasePrice) /
                                                businessUnitTotalPurchasePrice
                                                  ?.grandTotal?.[
                                                  businessUnit?.id
                                                ]) *
                                              100
                                            ).toFixed(2) + "%"
                                          : "-"}
                                      </div>
                                      <div
                                        className="border-end width-70   text-center pt-2"
                                        title={`Total Base Units ${product?.baseUnit}`}
                                      >
                                        {product?.purchasePrice &&
                                        product?.baseUnit ? (
                                          <>
                                            ISK{" "}
                                            {currencyFormatter
                                              .format(
                                                Number(product?.purchasePrice) /
                                                  (product?.baseUnit > 0
                                                    ? Number(product?.baseUnit)
                                                    : 1),
                                                {
                                                  code: "ISK",
                                                }
                                              )
                                              .replace("kr.", "")
                                              .trim()}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment key={businessUnit.id}>
                                      <div className="border-end width-70 text-center pt-2"></div>
                                      <div className="border-end width-70 text-center pt-2"></div>
                                      <div className="border-end width-70 text-center pt-2"></div>
                                    </React.Fragment>
                                  )
                                )}
                            </div>
                          </>
                        ))}

                      {/* Total Start */}
                      <div
                        className="d-flex border-top border-bottom fixed-bottom-total-2"
                        style={{
                          width: `${
                            (businessUnitData.length + 1) * 210 + 160
                          }px`,
                        }}
                      >
                        <div className="border-end border-start classification-name fixed-column">
                          Total
                        </div>
                        <div className="fixed-column-2 d-flex">
                          <div
                            className="border-end width-70   text-center pt-2"
                            title="Total Purchase Amount"
                          >
                            ISK{" "}
                            {currencyFormatter
                              .format(unclassifiedProductTotalPurchasePrice, {
                                code: "ISK",
                              })
                              .replace("kr.", "")
                              .trim()}
                          </div>
                          <div
                            className="border-end width-70   text-center pt-2"
                            title="Percentage of Total Purchase Amount"
                          >
                            {grandTotalPurchaseAmountCombined &&
                              unclassifiedProductTotalPurchasePrice &&
                              ((
                                (unclassifiedProductTotalPurchasePrice /
                                  grandTotalPurchaseAmountCombined) *
                                100
                              ).toFixed(2) + "%" ||
                                "")}
                          </div>
                          <div
                            className="border-end width-70   text-center pt-2"
                            title="Average Of Base Unit Price"
                          ></div>
                        </div>
                        {businessUnitData &&
                          businessUnitData.map((businessUnit, index) => (
                            <>
                              <div
                                className="border-end width-70   text-center pt-2"
                                title="Total Purchase Amount"
                              >
                                {businessUnitTotalPurchasePrice?.unclassified?.[
                                  businessUnit.id
                                ]
                                  ? `ISK ` +
                                    currencyFormatter
                                      .format(
                                        businessUnitTotalPurchasePrice
                                          ?.unclassified?.[businessUnit.id],
                                        {
                                          code: "ISK",
                                        }
                                      )
                                      .replace("kr.", "")
                                      .trim()
                                  : 0}
                              </div>
                              <div
                                className="border-end width-70   text-center pt-2"
                                title="Percentage of Total Purchase Amount"
                              >
                                {businessUnitTotalPurchasePrice?.grandTotal?.[
                                  businessUnit.id
                                ] &&
                                businessUnitTotalPurchasePrice?.unclassified?.[
                                  businessUnit.id
                                ]
                                  ? (
                                      (businessUnitTotalPurchasePrice
                                        ?.unclassified?.[businessUnit.id] /
                                        businessUnitTotalPurchasePrice
                                          ?.grandTotal?.[businessUnit.id]) *
                                      100
                                    ).toFixed(2) + "%"
                                  : ""}
                              </div>
                              <div
                                className="border-end width-70   text-center pt-2"
                                title="Average Of Base Unit Price"
                              ></div>
                            </>
                          ))}
                      </div>
                      {/* Total End */}
                    </div>
                  </div>
                )}

                {/* Grand Total Start */}
                <div
                  className="mb-5 poSrch ponew mt-5"
                  style={{ overflowY: "auto" }}
                >
                  <div
                    className="d-flex fixed-header"
                    style={{
                      width: `${(businessUnitData.length + 1) * 210 + 160}px`,
                    }}
                  >
                    <div className="py-3 pt-3 border-end border-start border-top classification-name fixed-column">
                      Grand Total
                    </div>
                    <div className="py-3 pt-3 border-end border-top bUnitName fixed-column-2 pt-1">
                      All Business Units Combined
                    </div>
                    {businessUnitData &&
                      businessUnitData.map((businessUnit, index) => (
                        <div className="py-3 pt-3 border-end border-top bUnitName pt-1">
                          {businessUnit?.name}
                        </div>
                      ))}
                  </div>

                  <div
                    className="d-flex border-top border-bottom fixed-bottom-total-2"
                    style={{
                      width: `${(businessUnitData.length + 1) * 210 + 160}px`,
                    }}
                  >
                    <div className="py-3 pt-3 border-end border-start classification-name fixed-column">
                      Classified + Unclassified
                    </div>
                    <div className="fixed-column-2 d-flex">
                      <div
                        className="py-3 pt-3 border-end width-105 text-center pt-2"
                        title="Total Purchase Amount"
                      >
                        ISK{" "}
                        {currencyFormatter
                          .format(grandTotalPurchaseAmountCombined, {
                            code: "ISK",
                          })
                          .replace("kr.", "")
                          .trim()}
                      </div>
                      <div
                        className="py-3 pt-3 border-end width-105 text-center pt-2"
                        title="Percentage of Total Purchase Amount"
                      >
                        {"100%"}
                      </div>
                    </div>
                    {businessUnitData &&
                      businessUnitData.map((businessUnit, index) => (
                        <>
                          <div
                            className="py-3 pt-3 border-end width-105 text-center pt-2"
                            title="Total Purchase Amount"
                          >
                            {businessUnitTotalPurchasePrice?.grandTotal?.[
                              businessUnit.id
                            ]
                              ? `ISK ` +
                                currencyFormatter
                                  .format(
                                    businessUnitTotalPurchasePrice
                                      ?.grandTotal?.[businessUnit.id],
                                    {
                                      code: "ISK",
                                    }
                                  )
                                  .replace("kr.", "")
                                  .trim()
                              : 0}
                          </div>
                          <div
                            className="py-3 pt-3 border-end width-105 text-center pt-2"
                            title="Percentage of Total Purchase Amount"
                          >
                            {"100%"}
                          </div>
                        </>
                      ))}
                  </div>
                </div>
                {/* Grand Total End */}

                <div></div>
                {/* Unclassified Report End*/}
              </div>
            </div>
            {/* UNSPSC Report End*/}
          </div>
        </div>
      </div>

      {/* Model to show Purchase History Start*/}
      <div>
        <Modal
          size="lg"
          show={showPurchaseModal}
          onHide={() => setShowPurchaseModal(false)}
          dialogClassName="custom-modal-size"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="mb-3">{t("purchaseHistory")}</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("orderId")}</th>
                    <th>{t("Order Date")}</th>
                    <th>{t("User")}</th>
                    <th>{t("productNumber")}</th>
                    <th>{t("productName")}</th>
                    <th>{t("Purchase Quantity")}</th>
                    <th>{t("co2_qty")}</th>
                    <th>{t("kgco2")}</th>
                    <th>{t("Price")}</th>
                    <th>{t("Change Percentage")}</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedProductDetails?.PurchaseHistories?.length > 0 &&
                    selectedProductDetails?.PurchaseHistories
                      ?.sort(
                        (a, b) =>
                          new Date(b?.createdAt) - new Date(a?.createdAt)
                      )
                      ?.map((item) => {
                        return (
                          <tr key={item.id} className="">
                            <td data-label="Order ID">
                              <Link
                                to={`/pastorderedit?id=${selectedPastOrderDetails.id}&invoiceId=${selectedInvoiceId}`}
                                target="_blank"
                                className="text-primary"
                                title="View Order Details"
                              >
                                <i className="fa-solid fa-up-right-from-square me-1"></i>
                                {selectedProductDetails?.pastOrder?.id}
                              </Link>
                            </td>
                            <td data-label="Order Date">
                              {moment(item.createdAt).format("DD-MM-YYYY")}
                            </td>
                            <td data-label="User Name">
                              {`${item?.User?.firstName} ${item?.User?.lastName}`}
                            </td>
                            <td data-label="Product Number">
                            <Link
                                to={`/productdetails?id=${selectedProductDetails.id}`}
                                target="_blank"
                                className="text-primary"
                                title="View Order Details"
                              >
                              {`${selectedProductDetails?.number}`}
                              </Link>
                            </td>
                            <td data-label="Product Name">
                              {`${selectedProductDetails.name}`}
                            </td>
                            <td data-label="Total Quantity per Base units">
                              {item.totalQuantityPerBaseUnits}
                            </td>
                            <td data-label="CO2e">
                             {selectedProductDetails?.co2_qty}
                            </td>
                            <td data-label="KgCO2e">
                            {selectedProductDetails?.kgco2_co2_unit}
                            </td>
                            <td data-label="Base unit Price">
                              {item.currencyType}{" "}
                              {currencyFormatter
                                .format(item.saleUnit, {
                                  code: "ISK",
                                })
                                .replace("kr.", "")
                                .trim()}
                            </td>
                            <td data-label="Change In Percentage">
                              {item?.changePercentage
                                ? `${Number(item?.changePercentage).toFixed(
                                    2
                                  )} %`
                                : ""}
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      {/* Model to show Purchase History End */}
    </div>
  );
};

export default Report;
